/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  bytea: any;
  citext: any;
  jsonb: any;
  point: any;
  timestamptz: any;
  tsvector: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CheckImagePayload = {
  __typename?: 'CheckImagePayload';
  error?: Maybe<Scalars['String']>;
  existing_url?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type UploadImagePayload = {
  __typename?: 'UploadImagePayload';
  error?: Maybe<Scalars['String']>;
  fixed_url?: Maybe<Scalars['String']>;
  new_url?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** advertising stuff */
export type Ad = {
  __typename?: 'ad';
  /** An array relationship */
  ad_cycles: Array<Ad_Cycle>;
  /** An aggregate relationship */
  ad_cycles_aggregate: Ad_Cycle_Aggregate;
  /** An array relationship */
  ad_events: Array<Ad_Event>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Event_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  image: Scalars['String'];
  last_viewed: Scalars['timestamptz'];
  link: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** advertising stuff */
export type AdAd_CyclesArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


/** advertising stuff */
export type AdAd_Cycles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


/** advertising stuff */
export type AdAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


/** advertising stuff */
export type AdAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};

/** aggregated selection of "ad" */
export type Ad_Aggregate = {
  __typename?: 'ad_aggregate';
  aggregate?: Maybe<Ad_Aggregate_Fields>;
  nodes: Array<Ad>;
};

/** aggregate fields of "ad" */
export type Ad_Aggregate_Fields = {
  __typename?: 'ad_aggregate_fields';
  avg?: Maybe<Ad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ad_Max_Fields>;
  min?: Maybe<Ad_Min_Fields>;
  stddev?: Maybe<Ad_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Sum_Fields>;
  var_pop?: Maybe<Ad_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Var_Samp_Fields>;
  variance?: Maybe<Ad_Variance_Fields>;
};


/** aggregate fields of "ad" */
export type Ad_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ad_Avg_Fields = {
  __typename?: 'ad_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad". All fields are combined with a logical 'AND'. */
export type Ad_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Bool_Exp>>;
  _not?: InputMaybe<Ad_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Bool_Exp>>;
  ad_cycles?: InputMaybe<Ad_Cycle_Bool_Exp>;
  ad_cycles_aggregate?: InputMaybe<Ad_Cycle_Aggregate_Bool_Exp>;
  ad_events?: InputMaybe<Ad_Event_Bool_Exp>;
  ad_events_aggregate?: InputMaybe<Ad_Event_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  last_viewed?: InputMaybe<Timestamptz_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad" */
export enum Ad_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdPkey = 'ad_pkey'
}

/** Specific run of an ad */
export type Ad_Cycle = {
  __typename?: 'ad_cycle';
  /** An object relationship */
  ad: Ad;
  /** An array relationship */
  ad_events: Array<Ad_Event>;
  /** An aggregate relationship */
  ad_events_aggregate: Ad_Event_Aggregate;
  ad_id: Scalars['Int'];
  ends_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  loads: Scalars['Int'];
  paused: Scalars['Boolean'];
  starts_at: Scalars['timestamptz'];
};


/** Specific run of an ad */
export type Ad_CycleAd_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


/** Specific run of an ad */
export type Ad_CycleAd_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};

/** aggregated selection of "ad_cycle" */
export type Ad_Cycle_Aggregate = {
  __typename?: 'ad_cycle_aggregate';
  aggregate?: Maybe<Ad_Cycle_Aggregate_Fields>;
  nodes: Array<Ad_Cycle>;
};

export type Ad_Cycle_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ad_Cycle_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ad_Cycle_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ad_Cycle_Aggregate_Bool_Exp_Count>;
};

export type Ad_Cycle_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ad_Cycle_Select_Column_Ad_Cycle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Cycle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Cycle_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ad_Cycle_Select_Column_Ad_Cycle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Cycle_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Cycle_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Cycle_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad_cycle" */
export type Ad_Cycle_Aggregate_Fields = {
  __typename?: 'ad_cycle_aggregate_fields';
  avg?: Maybe<Ad_Cycle_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ad_Cycle_Max_Fields>;
  min?: Maybe<Ad_Cycle_Min_Fields>;
  stddev?: Maybe<Ad_Cycle_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Cycle_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Cycle_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Cycle_Sum_Fields>;
  var_pop?: Maybe<Ad_Cycle_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Cycle_Var_Samp_Fields>;
  variance?: Maybe<Ad_Cycle_Variance_Fields>;
};


/** aggregate fields of "ad_cycle" */
export type Ad_Cycle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_cycle" */
export type Ad_Cycle_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Cycle_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Cycle_Max_Order_By>;
  min?: InputMaybe<Ad_Cycle_Min_Order_By>;
  stddev?: InputMaybe<Ad_Cycle_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Cycle_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Cycle_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Cycle_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Cycle_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Cycle_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Cycle_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_cycle" */
export type Ad_Cycle_Arr_Rel_Insert_Input = {
  data: Array<Ad_Cycle_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Cycle_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Cycle_Avg_Fields = {
  __typename?: 'ad_cycle_avg_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_cycle" */
export type Ad_Cycle_Avg_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_cycle". All fields are combined with a logical 'AND'. */
export type Ad_Cycle_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Cycle_Bool_Exp>>;
  _not?: InputMaybe<Ad_Cycle_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Cycle_Bool_Exp>>;
  ad?: InputMaybe<Ad_Bool_Exp>;
  ad_events?: InputMaybe<Ad_Event_Bool_Exp>;
  ad_events_aggregate?: InputMaybe<Ad_Event_Aggregate_Bool_Exp>;
  ad_id?: InputMaybe<Int_Comparison_Exp>;
  ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  loads?: InputMaybe<Int_Comparison_Exp>;
  paused?: InputMaybe<Boolean_Comparison_Exp>;
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_cycle" */
export enum Ad_Cycle_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdCyclePkey = 'ad_cycle_pkey'
}

/** input type for incrementing numeric columns in table "ad_cycle" */
export type Ad_Cycle_Inc_Input = {
  ad_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  loads?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ad_cycle" */
export type Ad_Cycle_Insert_Input = {
  ad?: InputMaybe<Ad_Obj_Rel_Insert_Input>;
  ad_events?: InputMaybe<Ad_Event_Arr_Rel_Insert_Input>;
  ad_id?: InputMaybe<Scalars['Int']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  loads?: InputMaybe<Scalars['Int']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ad_Cycle_Max_Fields = {
  __typename?: 'ad_cycle_max_fields';
  ad_id?: Maybe<Scalars['Int']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  loads?: Maybe<Scalars['Int']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ad_cycle" */
export type Ad_Cycle_Max_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Cycle_Min_Fields = {
  __typename?: 'ad_cycle_min_fields';
  ad_id?: Maybe<Scalars['Int']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  loads?: Maybe<Scalars['Int']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ad_cycle" */
export type Ad_Cycle_Min_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_cycle" */
export type Ad_Cycle_Mutation_Response = {
  __typename?: 'ad_cycle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Cycle>;
};

/** input type for inserting object relation for remote table "ad_cycle" */
export type Ad_Cycle_Obj_Rel_Insert_Input = {
  data: Ad_Cycle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Cycle_On_Conflict>;
};

/** on_conflict condition type for table "ad_cycle" */
export type Ad_Cycle_On_Conflict = {
  constraint: Ad_Cycle_Constraint;
  update_columns?: Array<Ad_Cycle_Update_Column>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_cycle". */
export type Ad_Cycle_Order_By = {
  ad?: InputMaybe<Ad_Order_By>;
  ad_events_aggregate?: InputMaybe<Ad_Event_Aggregate_Order_By>;
  ad_id?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
  paused?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad_cycle */
export type Ad_Cycle_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ad_cycle" */
export enum Ad_Cycle_Select_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  Id = 'id',
  /** column name */
  Loads = 'loads',
  /** column name */
  Paused = 'paused',
  /** column name */
  StartsAt = 'starts_at'
}

/** select "ad_cycle_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_cycle" */
export enum Ad_Cycle_Select_Column_Ad_Cycle_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Paused = 'paused'
}

/** select "ad_cycle_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_cycle" */
export enum Ad_Cycle_Select_Column_Ad_Cycle_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Paused = 'paused'
}

/** input type for updating data in table "ad_cycle" */
export type Ad_Cycle_Set_Input = {
  ad_id?: InputMaybe<Scalars['Int']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  loads?: InputMaybe<Scalars['Int']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ad_Cycle_Stddev_Fields = {
  __typename?: 'ad_cycle_stddev_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_cycle" */
export type Ad_Cycle_Stddev_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Cycle_Stddev_Pop_Fields = {
  __typename?: 'ad_cycle_stddev_pop_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_cycle" */
export type Ad_Cycle_Stddev_Pop_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Cycle_Stddev_Samp_Fields = {
  __typename?: 'ad_cycle_stddev_samp_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_cycle" */
export type Ad_Cycle_Stddev_Samp_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_cycle" */
export type Ad_Cycle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Cycle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Cycle_Stream_Cursor_Value_Input = {
  ad_id?: InputMaybe<Scalars['Int']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  loads?: InputMaybe<Scalars['Int']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ad_Cycle_Sum_Fields = {
  __typename?: 'ad_cycle_sum_fields';
  ad_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  loads?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ad_cycle" */
export type Ad_Cycle_Sum_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** update columns of table "ad_cycle" */
export enum Ad_Cycle_Update_Column {
  /** column name */
  AdId = 'ad_id',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  Id = 'id',
  /** column name */
  Loads = 'loads',
  /** column name */
  Paused = 'paused',
  /** column name */
  StartsAt = 'starts_at'
}

export type Ad_Cycle_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Cycle_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Cycle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Cycle_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Cycle_Var_Pop_Fields = {
  __typename?: 'ad_cycle_var_pop_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_cycle" */
export type Ad_Cycle_Var_Pop_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Cycle_Var_Samp_Fields = {
  __typename?: 'ad_cycle_var_samp_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_cycle" */
export type Ad_Cycle_Var_Samp_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Cycle_Variance_Fields = {
  __typename?: 'ad_cycle_variance_fields';
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  loads?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_cycle" */
export type Ad_Cycle_Variance_Order_By = {
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loads?: InputMaybe<Order_By>;
};

/** tracking significant events: impressions and clicks */
export type Ad_Event = {
  __typename?: 'ad_event';
  /** An object relationship */
  ad: Ad;
  /** An object relationship */
  ad_cycle: Ad_Cycle;
  ad_cycle_id: Scalars['Int'];
  ad_id: Scalars['Int'];
  event_type: Scalars['String'];
  id: Scalars['Int'];
  placement_identifier?: Maybe<Scalars['String']>;
  timestamp: Scalars['timestamptz'];
  unique: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ad_event" */
export type Ad_Event_Aggregate = {
  __typename?: 'ad_event_aggregate';
  aggregate?: Maybe<Ad_Event_Aggregate_Fields>;
  nodes: Array<Ad_Event>;
};

export type Ad_Event_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ad_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ad_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ad_Event_Aggregate_Bool_Exp_Count>;
};

export type Ad_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ad_Event_Select_Column_Ad_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ad_Event_Select_Column_Ad_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ad_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ad_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ad_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ad_event" */
export type Ad_Event_Aggregate_Fields = {
  __typename?: 'ad_event_aggregate_fields';
  avg?: Maybe<Ad_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ad_Event_Max_Fields>;
  min?: Maybe<Ad_Event_Min_Fields>;
  stddev?: Maybe<Ad_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Ad_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ad_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Ad_Event_Sum_Fields>;
  var_pop?: Maybe<Ad_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Ad_Event_Var_Samp_Fields>;
  variance?: Maybe<Ad_Event_Variance_Fields>;
};


/** aggregate fields of "ad_event" */
export type Ad_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ad_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_event" */
export type Ad_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Ad_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ad_Event_Max_Order_By>;
  min?: InputMaybe<Ad_Event_Min_Order_By>;
  stddev?: InputMaybe<Ad_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ad_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ad_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ad_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Ad_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ad_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Ad_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ad_event" */
export type Ad_Event_Arr_Rel_Insert_Input = {
  data: Array<Ad_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_Event_On_Conflict>;
};

/** aggregate avg on columns */
export type Ad_Event_Avg_Fields = {
  __typename?: 'ad_event_avg_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_event" */
export type Ad_Event_Avg_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ad_event". All fields are combined with a logical 'AND'. */
export type Ad_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Ad_Event_Bool_Exp>>;
  _not?: InputMaybe<Ad_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Ad_Event_Bool_Exp>>;
  ad?: InputMaybe<Ad_Bool_Exp>;
  ad_cycle?: InputMaybe<Ad_Cycle_Bool_Exp>;
  ad_cycle_id?: InputMaybe<Int_Comparison_Exp>;
  ad_id?: InputMaybe<Int_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  placement_identifier?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  unique?: InputMaybe<Boolean_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ad_event" */
export enum Ad_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdEventPkey = 'ad_event_pkey'
}

/** input type for incrementing numeric columns in table "ad_event" */
export type Ad_Event_Inc_Input = {
  ad_cycle_id?: InputMaybe<Scalars['Int']>;
  ad_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ad_event" */
export type Ad_Event_Insert_Input = {
  ad?: InputMaybe<Ad_Obj_Rel_Insert_Input>;
  ad_cycle?: InputMaybe<Ad_Cycle_Obj_Rel_Insert_Input>;
  ad_cycle_id?: InputMaybe<Scalars['Int']>;
  ad_id?: InputMaybe<Scalars['Int']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  placement_identifier?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  unique?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ad_Event_Max_Fields = {
  __typename?: 'ad_event_max_fields';
  ad_cycle_id?: Maybe<Scalars['Int']>;
  ad_id?: Maybe<Scalars['Int']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  placement_identifier?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ad_event" */
export type Ad_Event_Max_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  placement_identifier?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ad_Event_Min_Fields = {
  __typename?: 'ad_event_min_fields';
  ad_cycle_id?: Maybe<Scalars['Int']>;
  ad_id?: Maybe<Scalars['Int']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  placement_identifier?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ad_event" */
export type Ad_Event_Min_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  placement_identifier?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ad_event" */
export type Ad_Event_Mutation_Response = {
  __typename?: 'ad_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad_Event>;
};

/** on_conflict condition type for table "ad_event" */
export type Ad_Event_On_Conflict = {
  constraint: Ad_Event_Constraint;
  update_columns?: Array<Ad_Event_Update_Column>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "ad_event". */
export type Ad_Event_Order_By = {
  ad?: InputMaybe<Ad_Order_By>;
  ad_cycle?: InputMaybe<Ad_Cycle_Order_By>;
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  placement_identifier?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unique?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad_event */
export type Ad_Event_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ad_event" */
export enum Ad_Event_Select_Column {
  /** column name */
  AdCycleId = 'ad_cycle_id',
  /** column name */
  AdId = 'ad_id',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  PlacementIdentifier = 'placement_identifier',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Unique = 'unique',
  /** column name */
  Url = 'url'
}

/** select "ad_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_event" */
export enum Ad_Event_Select_Column_Ad_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Unique = 'unique'
}

/** select "ad_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_event" */
export enum Ad_Event_Select_Column_Ad_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Unique = 'unique'
}

/** input type for updating data in table "ad_event" */
export type Ad_Event_Set_Input = {
  ad_cycle_id?: InputMaybe<Scalars['Int']>;
  ad_id?: InputMaybe<Scalars['Int']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  placement_identifier?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  unique?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ad_Event_Stddev_Fields = {
  __typename?: 'ad_event_stddev_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_event" */
export type Ad_Event_Stddev_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ad_Event_Stddev_Pop_Fields = {
  __typename?: 'ad_event_stddev_pop_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_event" */
export type Ad_Event_Stddev_Pop_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ad_Event_Stddev_Samp_Fields = {
  __typename?: 'ad_event_stddev_samp_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_event" */
export type Ad_Event_Stddev_Samp_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ad_event" */
export type Ad_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Event_Stream_Cursor_Value_Input = {
  ad_cycle_id?: InputMaybe<Scalars['Int']>;
  ad_id?: InputMaybe<Scalars['Int']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  placement_identifier?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  unique?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ad_Event_Sum_Fields = {
  __typename?: 'ad_event_sum_fields';
  ad_cycle_id?: Maybe<Scalars['Int']>;
  ad_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ad_event" */
export type Ad_Event_Sum_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "ad_event" */
export enum Ad_Event_Update_Column {
  /** column name */
  AdCycleId = 'ad_cycle_id',
  /** column name */
  AdId = 'ad_id',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  PlacementIdentifier = 'placement_identifier',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Unique = 'unique',
  /** column name */
  Url = 'url'
}

export type Ad_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Event_Var_Pop_Fields = {
  __typename?: 'ad_event_var_pop_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_event" */
export type Ad_Event_Var_Pop_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ad_Event_Var_Samp_Fields = {
  __typename?: 'ad_event_var_samp_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_event" */
export type Ad_Event_Var_Samp_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ad_Event_Variance_Fields = {
  __typename?: 'ad_event_variance_fields';
  ad_cycle_id?: Maybe<Scalars['Float']>;
  ad_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_event" */
export type Ad_Event_Variance_Order_By = {
  ad_cycle_id?: InputMaybe<Order_By>;
  ad_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "ad" */
export type Ad_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ad" */
export type Ad_Insert_Input = {
  ad_cycles?: InputMaybe<Ad_Cycle_Arr_Rel_Insert_Input>;
  ad_events?: InputMaybe<Ad_Event_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  last_viewed?: InputMaybe<Scalars['timestamptz']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ad_Max_Fields = {
  __typename?: 'ad_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  last_viewed?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ad_Min_Fields = {
  __typename?: 'ad_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  last_viewed?: Maybe<Scalars['timestamptz']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ad" */
export type Ad_Mutation_Response = {
  __typename?: 'ad_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ad>;
};

/** input type for inserting object relation for remote table "ad" */
export type Ad_Obj_Rel_Insert_Input = {
  data: Ad_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ad_On_Conflict>;
};

/** on_conflict condition type for table "ad" */
export type Ad_On_Conflict = {
  constraint: Ad_Constraint;
  update_columns?: Array<Ad_Update_Column>;
  where?: InputMaybe<Ad_Bool_Exp>;
};

/** Ordering options when selecting data from "ad". */
export type Ad_Order_By = {
  ad_cycles_aggregate?: InputMaybe<Ad_Cycle_Aggregate_Order_By>;
  ad_events_aggregate?: InputMaybe<Ad_Event_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  last_viewed?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ad */
export type Ad_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ad" */
export enum Ad_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  LastViewed = 'last_viewed',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ad" */
export type Ad_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  last_viewed?: InputMaybe<Scalars['timestamptz']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ad_Stddev_Fields = {
  __typename?: 'ad_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ad_Stddev_Pop_Fields = {
  __typename?: 'ad_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ad_Stddev_Samp_Fields = {
  __typename?: 'ad_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad" */
export type Ad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ad_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  last_viewed?: InputMaybe<Scalars['timestamptz']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ad_Sum_Fields = {
  __typename?: 'ad_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "ad" */
export enum Ad_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  LastViewed = 'last_viewed',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ad_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ad_Var_Pop_Fields = {
  __typename?: 'ad_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ad_Var_Samp_Fields = {
  __typename?: 'ad_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ad_Variance_Fields = {
  __typename?: 'ad_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequests = {
  __typename?: 'authOauth2AuthRequests';
  authTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  authorizationCodes: Array<AuthOauth2AuthorizationCodes>;
  /** An aggregate relationship */
  authorizationCodes_aggregate: AuthOauth2AuthorizationCodes_Aggregate;
  /** An object relationship */
  client: AuthOauth2Clients;
  clientId: Scalars['String'];
  codeChallenge?: Maybe<Scalars['String']>;
  codeChallengeMethod?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  done: Scalars['Boolean'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  nonce?: Maybe<Scalars['String']>;
  redirectUri: Scalars['String'];
  /** An array relationship */
  refreshTokens: Array<AuthOauth2RefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate;
  resource?: Maybe<Scalars['String']>;
  responseType: Scalars['String'];
  scopes: Array<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']>;
};


/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsAuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsAuthorizationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate = {
  __typename?: 'authOauth2AuthRequests_aggregate';
  aggregate?: Maybe<AuthOauth2AuthRequests_Aggregate_Fields>;
  nodes: Array<AuthOauth2AuthRequests>;
};

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Count>;
};

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And = {
  arguments: AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or = {
  arguments: AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_Fields = {
  __typename?: 'authOauth2AuthRequests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthOauth2AuthRequests_Max_Fields>;
  min?: Maybe<AuthOauth2AuthRequests_Min_Fields>;
};


/** aggregate fields of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthOauth2AuthRequests_Max_Order_By>;
  min?: InputMaybe<AuthOauth2AuthRequests_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2AuthRequests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.oauth2_auth_requests". All fields are combined with a logical 'AND'. */
export type AuthOauth2AuthRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2AuthRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthOauth2AuthRequests_Bool_Exp>>;
  authTime?: InputMaybe<Timestamptz_Comparison_Exp>;
  authorizationCodes?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
  authorizationCodes_aggregate?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp>;
  client?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  codeChallenge?: InputMaybe<String_Comparison_Exp>;
  codeChallengeMethod?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  done?: InputMaybe<Boolean_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nonce?: InputMaybe<String_Comparison_Exp>;
  redirectUri?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>;
  resource?: InputMaybe<String_Comparison_Exp>;
  responseType?: InputMaybe<String_Comparison_Exp>;
  scopes?: InputMaybe<String_Array_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  Oauth2AuthRequestsPkey = 'oauth2_auth_requests_pkey'
}

/** input type for inserting data into table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Insert_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']>;
  authorizationCodes?: InputMaybe<AuthOauth2AuthorizationCodes_Arr_Rel_Insert_Input>;
  client?: InputMaybe<AuthOauth2Clients_Obj_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['String']>;
  codeChallenge?: InputMaybe<Scalars['String']>;
  codeChallengeMethod?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  done?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  nonce?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  refreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>;
  resource?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthOauth2AuthRequests_Max_Fields = {
  __typename?: 'authOauth2AuthRequests_max_fields';
  authTime?: Maybe<Scalars['timestamptz']>;
  clientId?: Maybe<Scalars['String']>;
  codeChallenge?: Maybe<Scalars['String']>;
  codeChallengeMethod?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  nonce?: Maybe<Scalars['String']>;
  redirectUri?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  responseType?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Scalars['String']>>;
  state?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Max_Order_By = {
  authTime?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  codeChallenge?: InputMaybe<Order_By>;
  codeChallengeMethod?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  redirectUri?: InputMaybe<Order_By>;
  resource?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthOauth2AuthRequests_Min_Fields = {
  __typename?: 'authOauth2AuthRequests_min_fields';
  authTime?: Maybe<Scalars['timestamptz']>;
  clientId?: Maybe<Scalars['String']>;
  codeChallenge?: Maybe<Scalars['String']>;
  codeChallengeMethod?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  nonce?: Maybe<Scalars['String']>;
  redirectUri?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  responseType?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Scalars['String']>>;
  state?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Min_Order_By = {
  authTime?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  codeChallenge?: InputMaybe<Order_By>;
  codeChallengeMethod?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  redirectUri?: InputMaybe<Order_By>;
  resource?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Mutation_Response = {
  __typename?: 'authOauth2AuthRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2AuthRequests>;
};

/** input type for inserting object relation for remote table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Obj_Rel_Insert_Input = {
  data: AuthOauth2AuthRequests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>;
};

/** on_conflict condition type for table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_On_Conflict = {
  constraint: AuthOauth2AuthRequests_Constraint;
  update_columns?: Array<AuthOauth2AuthRequests_Update_Column>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.oauth2_auth_requests". */
export type AuthOauth2AuthRequests_Order_By = {
  authTime?: InputMaybe<Order_By>;
  authorizationCodes_aggregate?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Order_By>;
  client?: InputMaybe<AuthOauth2Clients_Order_By>;
  clientId?: InputMaybe<Order_By>;
  codeChallenge?: InputMaybe<Order_By>;
  codeChallengeMethod?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  done?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  redirectUri?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>;
  resource?: InputMaybe<Order_By>;
  responseType?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.oauth2_auth_requests */
export type AuthOauth2AuthRequests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column {
  /** column name */
  AuthTime = 'authTime',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CodeChallenge = 'codeChallenge',
  /** column name */
  CodeChallengeMethod = 'codeChallengeMethod',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Done = 'done',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  RedirectUri = 'redirectUri',
  /** column name */
  Resource = 'resource',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'userId'
}

/** select "authOauth2AuthRequests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Done = 'done'
}

/** select "authOauth2AuthRequests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Done = 'done'
}

/** input type for updating data in table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Set_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']>;
  clientId?: InputMaybe<Scalars['String']>;
  codeChallenge?: InputMaybe<Scalars['String']>;
  codeChallengeMethod?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  done?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  nonce?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authOauth2AuthRequests" */
export type AuthOauth2AuthRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2AuthRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthOauth2AuthRequests_Stream_Cursor_Value_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']>;
  clientId?: InputMaybe<Scalars['String']>;
  codeChallenge?: InputMaybe<Scalars['String']>;
  codeChallengeMethod?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  done?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  nonce?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
  responseType?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Update_Column {
  /** column name */
  AuthTime = 'authTime',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CodeChallenge = 'codeChallenge',
  /** column name */
  CodeChallengeMethod = 'codeChallengeMethod',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Done = 'done',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  RedirectUri = 'redirectUri',
  /** column name */
  Resource = 'resource',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'userId'
}

export type AuthOauth2AuthRequests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthOauth2AuthRequests_Bool_Exp;
};

/** OAuth2 authorization codes pending exchange for tokens. */
export type AuthOauth2AuthorizationCodes = {
  __typename?: 'authOauth2AuthorizationCodes';
  /** An object relationship */
  authRequest: AuthOauth2AuthRequests;
  authRequestId: Scalars['uuid'];
  codeHash: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
};

/** aggregated selection of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate = {
  __typename?: 'authOauth2AuthorizationCodes_aggregate';
  aggregate?: Maybe<AuthOauth2AuthorizationCodes_Aggregate_Fields>;
  nodes: Array<AuthOauth2AuthorizationCodes>;
};

export type AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp_Count>;
};

export type AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthOauth2AuthorizationCodes_Max_Fields>;
  min?: Maybe<AuthOauth2AuthorizationCodes_Min_Fields>;
};


/** aggregate fields of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthOauth2AuthorizationCodes_Max_Order_By>;
  min?: InputMaybe<AuthOauth2AuthorizationCodes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2AuthorizationCodes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.oauth2_authorization_codes". All fields are combined with a logical 'AND'. */
export type AuthOauth2AuthorizationCodes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Bool_Exp>>;
  _not?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Bool_Exp>>;
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  authRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  codeHash?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Constraint {
  /** unique or primary key constraint on columns "code_hash" */
  Oauth2AuthorizationCodesCodeHashKey = 'oauth2_authorization_codes_code_hash_key',
  /** unique or primary key constraint on columns "id" */
  Oauth2AuthorizationCodesPkey = 'oauth2_authorization_codes_pkey'
}

/** input type for inserting data into table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Insert_Input = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Obj_Rel_Insert_Input>;
  authRequestId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthOauth2AuthorizationCodes_Max_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_max_fields';
  authRequestId?: Maybe<Scalars['uuid']>;
  codeHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Max_Order_By = {
  authRequestId?: InputMaybe<Order_By>;
  codeHash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthOauth2AuthorizationCodes_Min_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_min_fields';
  authRequestId?: Maybe<Scalars['uuid']>;
  codeHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Min_Order_By = {
  authRequestId?: InputMaybe<Order_By>;
  codeHash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Mutation_Response = {
  __typename?: 'authOauth2AuthorizationCodes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2AuthorizationCodes>;
};

/** on_conflict condition type for table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_On_Conflict = {
  constraint: AuthOauth2AuthorizationCodes_Constraint;
  update_columns?: Array<AuthOauth2AuthorizationCodes_Update_Column>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.oauth2_authorization_codes". */
export type AuthOauth2AuthorizationCodes_Order_By = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Order_By>;
  authRequestId?: InputMaybe<Order_By>;
  codeHash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.oauth2_authorization_codes */
export type AuthOauth2AuthorizationCodes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Select_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Set_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authOauth2AuthorizationCodes" */
export type AuthOauth2AuthorizationCodes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2AuthorizationCodes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthOauth2AuthorizationCodes_Stream_Cursor_Value_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Update_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id'
}

export type AuthOauth2AuthorizationCodes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthOauth2AuthorizationCodes_Bool_Exp;
};

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2Clients = {
  __typename?: 'authOauth2Clients';
  /** An array relationship */
  authRequests: Array<AuthOauth2AuthRequests>;
  /** An aggregate relationship */
  authRequests_aggregate: AuthOauth2AuthRequests_Aggregate;
  clientId: Scalars['String'];
  clientSecretHash?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  createdByUser?: Maybe<Users>;
  metadata?: Maybe<Scalars['jsonb']>;
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  oauth2RefreshTokens: Array<AuthOauth2RefreshTokens>;
  /** An aggregate relationship */
  oauth2RefreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate;
  redirectUris: Array<Scalars['String']>;
  scopes: Array<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsAuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsAuthRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsOauth2RefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate = {
  __typename?: 'authOauth2Clients_aggregate';
  aggregate?: Maybe<AuthOauth2Clients_Aggregate_Fields>;
  nodes: Array<AuthOauth2Clients>;
};

/** aggregate fields of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate_Fields = {
  __typename?: 'authOauth2Clients_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthOauth2Clients_Max_Fields>;
  min?: Maybe<AuthOauth2Clients_Min_Fields>;
};


/** aggregate fields of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthOauth2Clients_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "auth.oauth2_clients". All fields are combined with a logical 'AND'. */
export type AuthOauth2Clients_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2Clients_Bool_Exp>>;
  _not?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
  _or?: InputMaybe<Array<AuthOauth2Clients_Bool_Exp>>;
  authRequests?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  authRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  clientSecretHash?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  createdByUser?: InputMaybe<Users_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  metadataDocumentFetchedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>;
  redirectUris?: InputMaybe<String_Array_Comparison_Exp>;
  scopes?: InputMaybe<String_Array_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Constraint {
  /** unique or primary key constraint on columns "client_id" */
  Oauth2ClientsPkey = 'oauth2_clients_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthOauth2Clients_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthOauth2Clients_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthOauth2Clients_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.oauth2_clients" */
export type AuthOauth2Clients_Insert_Input = {
  authRequests?: InputMaybe<AuthOauth2AuthRequests_Arr_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecretHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdByUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>;
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AuthOauth2Clients_Max_Fields = {
  __typename?: 'authOauth2Clients_max_fields';
  clientId?: Maybe<Scalars['String']>;
  clientSecretHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']>;
  redirectUris?: Maybe<Array<Scalars['String']>>;
  scopes?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AuthOauth2Clients_Min_Fields = {
  __typename?: 'authOauth2Clients_min_fields';
  clientId?: Maybe<Scalars['String']>;
  clientSecretHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']>;
  redirectUris?: Maybe<Array<Scalars['String']>>;
  scopes?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "auth.oauth2_clients" */
export type AuthOauth2Clients_Mutation_Response = {
  __typename?: 'authOauth2Clients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2Clients>;
};

/** input type for inserting object relation for remote table "auth.oauth2_clients" */
export type AuthOauth2Clients_Obj_Rel_Insert_Input = {
  data: AuthOauth2Clients_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>;
};

/** on_conflict condition type for table "auth.oauth2_clients" */
export type AuthOauth2Clients_On_Conflict = {
  constraint: AuthOauth2Clients_Constraint;
  update_columns?: Array<AuthOauth2Clients_Update_Column>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.oauth2_clients". */
export type AuthOauth2Clients_Order_By = {
  authRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientSecretHash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<Users_Order_By>;
  metadata?: InputMaybe<Order_By>;
  metadataDocumentFetchedAt?: InputMaybe<Order_By>;
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>;
  redirectUris?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.oauth2_clients */
export type AuthOauth2Clients_Pk_Columns_Input = {
  clientId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthOauth2Clients_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Select_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecretHash = 'clientSecretHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataDocumentFetchedAt = 'metadataDocumentFetchedAt',
  /** column name */
  RedirectUris = 'redirectUris',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "auth.oauth2_clients" */
export type AuthOauth2Clients_Set_Input = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecretHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "authOauth2Clients" */
export type AuthOauth2Clients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2Clients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthOauth2Clients_Stream_Cursor_Value_Input = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecretHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']>;
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Update_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecretHash = 'clientSecretHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataDocumentFetchedAt = 'metadataDocumentFetchedAt',
  /** column name */
  RedirectUris = 'redirectUris',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AuthOauth2Clients_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthOauth2Clients_Bool_Exp;
};

/** OAuth2 refresh tokens with client and scope binding. */
export type AuthOauth2RefreshTokens = {
  __typename?: 'authOauth2RefreshTokens';
  /** An object relationship */
  authRequest?: Maybe<AuthOauth2AuthRequests>;
  authRequestId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  client: AuthOauth2Clients;
  clientId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  scopes: Array<Scalars['String']>;
  tokenHash: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate = {
  __typename?: 'authOauth2RefreshTokens_aggregate';
  aggregate?: Maybe<AuthOauth2RefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthOauth2RefreshTokens>;
};

export type AuthOauth2RefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthOauth2RefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_Fields = {
  __typename?: 'authOauth2RefreshTokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthOauth2RefreshTokens_Max_Fields>;
  min?: Maybe<AuthOauth2RefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthOauth2RefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthOauth2RefreshTokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2RefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.oauth2_refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthOauth2RefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2RefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthOauth2RefreshTokens_Bool_Exp>>;
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  authRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  client?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  scopes?: InputMaybe<String_Array_Comparison_Exp>;
  tokenHash?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  Oauth2RefreshTokensPkey = 'oauth2_refresh_tokens_pkey',
  /** unique or primary key constraint on columns "token_hash" */
  Oauth2RefreshTokensTokenHashKey = 'oauth2_refresh_tokens_token_hash_key'
}

/** input type for inserting data into table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Insert_Input = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Obj_Rel_Insert_Input>;
  authRequestId?: InputMaybe<Scalars['uuid']>;
  client?: InputMaybe<AuthOauth2Clients_Obj_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  tokenHash?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthOauth2RefreshTokens_Max_Fields = {
  __typename?: 'authOauth2RefreshTokens_max_fields';
  authRequestId?: Maybe<Scalars['uuid']>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  scopes?: Maybe<Array<Scalars['String']>>;
  tokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Max_Order_By = {
  authRequestId?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthOauth2RefreshTokens_Min_Fields = {
  __typename?: 'authOauth2RefreshTokens_min_fields';
  authRequestId?: Maybe<Scalars['uuid']>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  scopes?: Maybe<Array<Scalars['String']>>;
  tokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Min_Order_By = {
  authRequestId?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Mutation_Response = {
  __typename?: 'authOauth2RefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2RefreshTokens>;
};

/** on_conflict condition type for table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_On_Conflict = {
  constraint: AuthOauth2RefreshTokens_Constraint;
  update_columns?: Array<AuthOauth2RefreshTokens_Update_Column>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.oauth2_refresh_tokens". */
export type AuthOauth2RefreshTokens_Order_By = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Order_By>;
  authRequestId?: InputMaybe<Order_By>;
  client?: InputMaybe<AuthOauth2Clients_Order_By>;
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.oauth2_refresh_tokens */
export type AuthOauth2RefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Select_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  TokenHash = 'tokenHash',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Set_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  tokenHash?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authOauth2RefreshTokens" */
export type AuthOauth2RefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2RefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthOauth2RefreshTokens_Stream_Cursor_Value_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
  tokenHash?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Update_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  TokenHash = 'tokenHash',
  /** column name */
  UserId = 'userId'
}

export type AuthOauth2RefreshTokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthOauth2RefreshTokens_Bool_Exp;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid'];
  options?: Maybe<Scalars['jsonb']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  options?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  options?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  options?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders';
  id: Scalars['String'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokenTypes>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  type: AuthRefreshTokenTypes_Enum;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  refreshTokenHash?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  refreshTokenHash?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  refreshTokenHash?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  refreshTokenHash?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles';
  role: Scalars['String'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String'];
  providerUserId: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<AuthProviders_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providerUserId?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUserId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<AuthProviders_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providerUserId?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUserId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerUserId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  role: Scalars['String'];
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<AuthRoles_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint'];
  credentialId: Scalars['String'];
  credentialPublicKey?: Maybe<Scalars['bytea']>;
  id: Scalars['uuid'];
  nickname?: Maybe<Scalars['String']>;
  transports: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']>;
  credentialId?: InputMaybe<Scalars['String']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']>;
  id?: InputMaybe<Scalars['uuid']>;
  nickname?: InputMaybe<Scalars['String']>;
  transports?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  credentialPublicKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']>;
  credentialId?: InputMaybe<Scalars['String']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']>;
  id?: InputMaybe<Scalars['uuid']>;
  nickname?: InputMaybe<Scalars['String']>;
  transports?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']>;
  credentialId?: InputMaybe<Scalars['String']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']>;
  id?: InputMaybe<Scalars['uuid']>;
  nickname?: InputMaybe<Scalars['String']>;
  transports?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  downloadExpiration: Scalars['Int'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String'];
  maxUploadFileSize: Scalars['Int'];
  minUploadFileSize: Scalars['Int'];
  presignedUrlsEnabled: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downloadExpiration?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downloadExpiration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  downloadExpiration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']>;
  _gt?: InputMaybe<Scalars['bytea']>;
  _gte?: InputMaybe<Scalars['bytea']>;
  _in?: InputMaybe<Array<Scalars['bytea']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bytea']>;
  _lte?: InputMaybe<Scalars['bytea']>;
  _neq?: InputMaybe<Scalars['bytea']>;
  _nin?: InputMaybe<Array<Scalars['bytea']>>;
};

/** sub category organization */
export type Category_Tag = {
  __typename?: 'category_tag';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_primary: Scalars['Boolean'];
  label: Scalars['String'];
  /** An array relationship */
  listing_category_tags: Array<Listing_Category_Tag>;
  /** An aggregate relationship */
  listing_category_tags_aggregate: Listing_Category_Tag_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** sub category organization */
export type Category_TagListing_Category_TagsArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


/** sub category organization */
export type Category_TagListing_Category_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};

/** aggregated selection of "category_tag" */
export type Category_Tag_Aggregate = {
  __typename?: 'category_tag_aggregate';
  aggregate?: Maybe<Category_Tag_Aggregate_Fields>;
  nodes: Array<Category_Tag>;
};

/** aggregate fields of "category_tag" */
export type Category_Tag_Aggregate_Fields = {
  __typename?: 'category_tag_aggregate_fields';
  avg?: Maybe<Category_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Category_Tag_Max_Fields>;
  min?: Maybe<Category_Tag_Min_Fields>;
  stddev?: Maybe<Category_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Category_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Category_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Category_Tag_Sum_Fields>;
  var_pop?: Maybe<Category_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Category_Tag_Var_Samp_Fields>;
  variance?: Maybe<Category_Tag_Variance_Fields>;
};


/** aggregate fields of "category_tag" */
export type Category_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Category_Tag_Avg_Fields = {
  __typename?: 'category_tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "category_tag". All fields are combined with a logical 'AND'. */
export type Category_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Tag_Bool_Exp>>;
  _not?: InputMaybe<Category_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Tag_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  listing_category_tags?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
  listing_category_tags_aggregate?: InputMaybe<Listing_Category_Tag_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_tag" */
export enum Category_Tag_Constraint {
  /** unique or primary key constraint on columns "label" */
  CategoryTagsLabelKey = 'category_tags_label_key',
  /** unique or primary key constraint on columns "id" */
  CategoryTagsPkey = 'category_tags_pkey'
}

/** input type for incrementing numeric columns in table "category_tag" */
export type Category_Tag_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "category_tag" */
export type Category_Tag_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  listing_category_tags?: InputMaybe<Listing_Category_Tag_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Category_Tag_Max_Fields = {
  __typename?: 'category_tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Category_Tag_Min_Fields = {
  __typename?: 'category_tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "category_tag" */
export type Category_Tag_Mutation_Response = {
  __typename?: 'category_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category_Tag>;
};

/** input type for inserting object relation for remote table "category_tag" */
export type Category_Tag_Obj_Rel_Insert_Input = {
  data: Category_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_Tag_On_Conflict>;
};

/** on_conflict condition type for table "category_tag" */
export type Category_Tag_On_Conflict = {
  constraint: Category_Tag_Constraint;
  update_columns?: Array<Category_Tag_Update_Column>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "category_tag". */
export type Category_Tag_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  listing_category_tags_aggregate?: InputMaybe<Listing_Category_Tag_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_tag */
export type Category_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "category_tag" */
export enum Category_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "category_tag" */
export type Category_Tag_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Category_Tag_Stddev_Fields = {
  __typename?: 'category_tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Category_Tag_Stddev_Pop_Fields = {
  __typename?: 'category_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Category_Tag_Stddev_Samp_Fields = {
  __typename?: 'category_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "category_tag" */
export type Category_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Category_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Category_Tag_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Category_Tag_Sum_Fields = {
  __typename?: 'category_tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "category_tag" */
export enum Category_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Category_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Category_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Category_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Category_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Category_Tag_Var_Pop_Fields = {
  __typename?: 'category_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Category_Tag_Var_Samp_Fields = {
  __typename?: 'category_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Category_Tag_Variance_Fields = {
  __typename?: 'category_tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']>;
  _gt?: InputMaybe<Scalars['citext']>;
  _gte?: InputMaybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']>;
  _in?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']>;
  _lt?: InputMaybe<Scalars['citext']>;
  _lte?: InputMaybe<Scalars['citext']>;
  _neq?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']>;
  _nin?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']>;
};

/** columns and relationships of "communication_opt_in" */
export type Communication_Opt_In = {
  __typename?: 'communication_opt_in';
  comm_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  opt_in: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "communication_opt_in" */
export type Communication_Opt_In_Aggregate = {
  __typename?: 'communication_opt_in_aggregate';
  aggregate?: Maybe<Communication_Opt_In_Aggregate_Fields>;
  nodes: Array<Communication_Opt_In>;
};

export type Communication_Opt_In_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Communication_Opt_In_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Communication_Opt_In_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Communication_Opt_In_Aggregate_Bool_Exp_Count>;
};

export type Communication_Opt_In_Aggregate_Bool_Exp_Bool_And = {
  arguments: Communication_Opt_In_Select_Column_Communication_Opt_In_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Communication_Opt_In_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Communication_Opt_In_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Communication_Opt_In_Select_Column_Communication_Opt_In_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Communication_Opt_In_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Communication_Opt_In_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Communication_Opt_In_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "communication_opt_in" */
export type Communication_Opt_In_Aggregate_Fields = {
  __typename?: 'communication_opt_in_aggregate_fields';
  avg?: Maybe<Communication_Opt_In_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Communication_Opt_In_Max_Fields>;
  min?: Maybe<Communication_Opt_In_Min_Fields>;
  stddev?: Maybe<Communication_Opt_In_Stddev_Fields>;
  stddev_pop?: Maybe<Communication_Opt_In_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Communication_Opt_In_Stddev_Samp_Fields>;
  sum?: Maybe<Communication_Opt_In_Sum_Fields>;
  var_pop?: Maybe<Communication_Opt_In_Var_Pop_Fields>;
  var_samp?: Maybe<Communication_Opt_In_Var_Samp_Fields>;
  variance?: Maybe<Communication_Opt_In_Variance_Fields>;
};


/** aggregate fields of "communication_opt_in" */
export type Communication_Opt_In_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "communication_opt_in" */
export type Communication_Opt_In_Aggregate_Order_By = {
  avg?: InputMaybe<Communication_Opt_In_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Communication_Opt_In_Max_Order_By>;
  min?: InputMaybe<Communication_Opt_In_Min_Order_By>;
  stddev?: InputMaybe<Communication_Opt_In_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Communication_Opt_In_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Communication_Opt_In_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Communication_Opt_In_Sum_Order_By>;
  var_pop?: InputMaybe<Communication_Opt_In_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Communication_Opt_In_Var_Samp_Order_By>;
  variance?: InputMaybe<Communication_Opt_In_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "communication_opt_in" */
export type Communication_Opt_In_Arr_Rel_Insert_Input = {
  data: Array<Communication_Opt_In_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Communication_Opt_In_On_Conflict>;
};

/** aggregate avg on columns */
export type Communication_Opt_In_Avg_Fields = {
  __typename?: 'communication_opt_in_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "communication_opt_in". All fields are combined with a logical 'AND'. */
export type Communication_Opt_In_Bool_Exp = {
  _and?: InputMaybe<Array<Communication_Opt_In_Bool_Exp>>;
  _not?: InputMaybe<Communication_Opt_In_Bool_Exp>;
  _or?: InputMaybe<Array<Communication_Opt_In_Bool_Exp>>;
  comm_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  opt_in?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "communication_opt_in" */
export enum Communication_Opt_In_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommunicationOptInPkey = 'communication_opt_in_pkey',
  /** unique or primary key constraint on columns "user_id", "comm_type" */
  CommunicationOptInUserIdCommTypeKey = 'communication_opt_in_user_id_comm_type_key'
}

/** input type for incrementing numeric columns in table "communication_opt_in" */
export type Communication_Opt_In_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "communication_opt_in" */
export type Communication_Opt_In_Insert_Input = {
  comm_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  opt_in?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Communication_Opt_In_Max_Fields = {
  __typename?: 'communication_opt_in_max_fields';
  comm_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Max_Order_By = {
  comm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Communication_Opt_In_Min_Fields = {
  __typename?: 'communication_opt_in_min_fields';
  comm_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Min_Order_By = {
  comm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "communication_opt_in" */
export type Communication_Opt_In_Mutation_Response = {
  __typename?: 'communication_opt_in_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Communication_Opt_In>;
};

/** on_conflict condition type for table "communication_opt_in" */
export type Communication_Opt_In_On_Conflict = {
  constraint: Communication_Opt_In_Constraint;
  update_columns?: Array<Communication_Opt_In_Update_Column>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};

/** Ordering options when selecting data from "communication_opt_in". */
export type Communication_Opt_In_Order_By = {
  comm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  opt_in?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: communication_opt_in */
export type Communication_Opt_In_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "communication_opt_in" */
export enum Communication_Opt_In_Select_Column {
  /** column name */
  CommType = 'comm_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OptIn = 'opt_in',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "communication_opt_in_aggregate_bool_exp_bool_and_arguments_columns" columns of table "communication_opt_in" */
export enum Communication_Opt_In_Select_Column_Communication_Opt_In_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  OptIn = 'opt_in'
}

/** select "communication_opt_in_aggregate_bool_exp_bool_or_arguments_columns" columns of table "communication_opt_in" */
export enum Communication_Opt_In_Select_Column_Communication_Opt_In_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  OptIn = 'opt_in'
}

/** input type for updating data in table "communication_opt_in" */
export type Communication_Opt_In_Set_Input = {
  comm_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  opt_in?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Communication_Opt_In_Stddev_Fields = {
  __typename?: 'communication_opt_in_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Communication_Opt_In_Stddev_Pop_Fields = {
  __typename?: 'communication_opt_in_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Communication_Opt_In_Stddev_Samp_Fields = {
  __typename?: 'communication_opt_in_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "communication_opt_in" */
export type Communication_Opt_In_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communication_Opt_In_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Communication_Opt_In_Stream_Cursor_Value_Input = {
  comm_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  opt_in?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Communication_Opt_In_Sum_Fields = {
  __typename?: 'communication_opt_in_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "communication_opt_in" */
export enum Communication_Opt_In_Update_Column {
  /** column name */
  CommType = 'comm_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OptIn = 'opt_in',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Communication_Opt_In_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Communication_Opt_In_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communication_Opt_In_Set_Input>;
  /** filter the rows which have to be updated */
  where: Communication_Opt_In_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Communication_Opt_In_Var_Pop_Fields = {
  __typename?: 'communication_opt_in_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Communication_Opt_In_Var_Samp_Fields = {
  __typename?: 'communication_opt_in_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Communication_Opt_In_Variance_Fields = {
  __typename?: 'communication_opt_in_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "communication_opt_in" */
export type Communication_Opt_In_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  etag?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isUploaded?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

export type Fuzzy_Category_Tag = {
  __typename?: 'fuzzy_category_tag';
  id: Scalars['Int'];
  is_primary: Scalars['Boolean'];
  label: Scalars['String'];
  listings_count: Scalars['bigint'];
  sim: Scalars['Float'];
};

/** Boolean expression to filter rows from the logical model for "fuzzy_category_tag". All fields are combined with a logical 'AND'. */
export type Fuzzy_Category_Tag_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Fuzzy_Category_Tag_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Fuzzy_Category_Tag_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Fuzzy_Category_Tag_Bool_Exp_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  listings_count?: InputMaybe<Bigint_Comparison_Exp>;
  sim?: InputMaybe<Float_Comparison_Exp>;
};

export enum Fuzzy_Category_Tag_Enum_Name {
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  Label = 'label',
  /** column name */
  ListingsCount = 'listings_count',
  /** column name */
  Sim = 'sim'
}

/** Ordering options when selecting data from "fuzzy_category_tag". */
export type Fuzzy_Category_Tag_Order_By = {
  id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  listings_count?: InputMaybe<Order_By>;
  sim?: InputMaybe<Order_By>;
};

export type Fuzzy_Listing = {
  __typename?: 'fuzzy_listing';
  business_name: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  island: Scalars['String'];
  layout_data: Scalars['jsonb'];
  slogan?: Maybe<Scalars['String']>;
};


export type Fuzzy_ListingLayout_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "fuzzy_listing". All fields are combined with a logical 'AND'. */
export type Fuzzy_Listing_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Fuzzy_Listing_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Fuzzy_Listing_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Fuzzy_Listing_Bool_Exp_Bool_Exp>>;
  business_name?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  island?: InputMaybe<String_Comparison_Exp>;
  layout_data?: InputMaybe<Jsonb_Comparison_Exp>;
  slogan?: InputMaybe<String_Comparison_Exp>;
};

export enum Fuzzy_Listing_Enum_Name {
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Island = 'island',
  /** column name */
  LayoutData = 'layout_data',
  /** column name */
  Slogan = 'slogan'
}

/** Ordering options when selecting data from "fuzzy_listing". */
export type Fuzzy_Listing_Order_By = {
  business_name?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  island?: InputMaybe<Order_By>;
  layout_data?: InputMaybe<Order_By>;
  slogan?: InputMaybe<Order_By>;
};

/** fuzzy_search_categoriesNative Query Arguments */
export type Fuzzy_Search_Categories_Arguments = {
  island?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
};

/** fuzzy_search_listingsNative Query Arguments */
export type Fuzzy_Search_Listings_Arguments = {
  include_non_live?: InputMaybe<Scalars['Boolean']>;
  island?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
};

/** mapping of images to source URLs, active URLs, and IDs */
export type Image = {
  __typename?: 'image';
  created_at: Scalars['timestamptz'];
  hash?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  source_url: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "image" */
export type Image_Aggregate = {
  __typename?: 'image_aggregate';
  aggregate?: Maybe<Image_Aggregate_Fields>;
  nodes: Array<Image>;
};

/** aggregate fields of "image" */
export type Image_Aggregate_Fields = {
  __typename?: 'image_aggregate_fields';
  avg?: Maybe<Image_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Image_Max_Fields>;
  min?: Maybe<Image_Min_Fields>;
  stddev?: Maybe<Image_Stddev_Fields>;
  stddev_pop?: Maybe<Image_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Image_Stddev_Samp_Fields>;
  sum?: Maybe<Image_Sum_Fields>;
  var_pop?: Maybe<Image_Var_Pop_Fields>;
  var_samp?: Maybe<Image_Var_Samp_Fields>;
  variance?: Maybe<Image_Variance_Fields>;
};


/** aggregate fields of "image" */
export type Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Image_Avg_Fields = {
  __typename?: 'image_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "image". All fields are combined with a logical 'AND'. */
export type Image_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Bool_Exp>>;
  _not?: InputMaybe<Image_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "image" */
export enum Image_Constraint {
  /** unique or primary key constraint on columns "hash" */
  ImageHashKey = 'image_hash_key',
  /** unique or primary key constraint on columns "id" */
  ImagePkey = 'image_pkey',
  /** unique or primary key constraint on columns "source_url" */
  ImageSourceUrlKey = 'image_source_url_key',
  /** unique or primary key constraint on columns "url" */
  ImageUrlKey = 'image_url_key'
}

/** input type for incrementing numeric columns in table "image" */
export type Image_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "image" */
export type Image_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  source_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Image_Max_Fields = {
  __typename?: 'image_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  source_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Image_Min_Fields = {
  __typename?: 'image_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  source_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "image" */
export type Image_Mutation_Response = {
  __typename?: 'image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Image>;
};

/** on_conflict condition type for table "image" */
export type Image_On_Conflict = {
  constraint: Image_Constraint;
  update_columns?: Array<Image_Update_Column>;
  where?: InputMaybe<Image_Bool_Exp>;
};

/** Ordering options when selecting data from "image". */
export type Image_Order_By = {
  created_at?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: image */
export type Image_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "image" */
export enum Image_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "image" */
export type Image_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  source_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Image_Stddev_Fields = {
  __typename?: 'image_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Image_Stddev_Pop_Fields = {
  __typename?: 'image_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Image_Stddev_Samp_Fields = {
  __typename?: 'image_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "image" */
export type Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  source_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Image_Sum_Fields = {
  __typename?: 'image_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "image" */
export enum Image_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Image_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Image_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Image_Var_Pop_Fields = {
  __typename?: 'image_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Image_Var_Samp_Fields = {
  __typename?: 'image_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Image_Variance_Fields = {
  __typename?: 'image_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** individual business's details */
export type Listing = {
  __typename?: 'listing';
  booking_links: Scalars['jsonb'];
  breadcrumbs?: Maybe<Scalars['jsonb']>;
  business_hours: Scalars['jsonb'];
  business_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images: Scalars['jsonb'];
  is_island_original: Scalars['Boolean'];
  island?: Maybe<Scalars['String']>;
  lat_lng?: Maybe<Scalars['point']>;
  layout_data: Scalars['jsonb'];
  /** An array relationship */
  listing_category_tags: Array<Listing_Category_Tag>;
  /** An aggregate relationship */
  listing_category_tags_aggregate: Listing_Category_Tag_Aggregate;
  live: Scalars['Boolean'];
  main_category_id?: Maybe<Scalars['Int']>;
  old_id?: Maybe<Scalars['String']>;
  paid_until?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "permalink_for_listing" */
  permalink?: Maybe<Scalars['String']>;
  primary_address?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  primary_web_url?: Maybe<Scalars['String']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
  promo_code_visitor_hook?: Maybe<Scalars['String']>;
  /** An array relationship */
  promo_codes: Array<Promo_Code>;
  /** An aggregate relationship */
  promo_codes_aggregate: Promo_Code_Aggregate;
  promoted: Scalars['Boolean'];
  rich_description?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  social_media: Scalars['jsonb'];
  this_week_recommended: Scalars['Boolean'];
  tier: Scalars['String'];
  ts_vector?: Maybe<Scalars['tsvector']>;
  updated_at: Scalars['timestamptz'];
  videos: Scalars['jsonb'];
};


/** individual business's details */
export type ListingBooking_LinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingBreadcrumbsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingBusiness_HoursArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingImagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingLayout_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingListing_Category_TagsArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


/** individual business's details */
export type ListingListing_Category_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


/** individual business's details */
export type ListingPromo_CodesArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


/** individual business's details */
export type ListingPromo_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


/** individual business's details */
export type ListingSocial_MediaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** individual business's details */
export type ListingVideosArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "listing" */
export type Listing_Aggregate = {
  __typename?: 'listing_aggregate';
  aggregate?: Maybe<Listing_Aggregate_Fields>;
  nodes: Array<Listing>;
};

/** aggregate fields of "listing" */
export type Listing_Aggregate_Fields = {
  __typename?: 'listing_aggregate_fields';
  avg?: Maybe<Listing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Listing_Max_Fields>;
  min?: Maybe<Listing_Min_Fields>;
  stddev?: Maybe<Listing_Stddev_Fields>;
  stddev_pop?: Maybe<Listing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Listing_Stddev_Samp_Fields>;
  sum?: Maybe<Listing_Sum_Fields>;
  var_pop?: Maybe<Listing_Var_Pop_Fields>;
  var_samp?: Maybe<Listing_Var_Samp_Fields>;
  variance?: Maybe<Listing_Variance_Fields>;
};


/** aggregate fields of "listing" */
export type Listing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Listing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Listing_Append_Input = {
  booking_links?: InputMaybe<Scalars['jsonb']>;
  breadcrumbs?: InputMaybe<Scalars['jsonb']>;
  business_hours?: InputMaybe<Scalars['jsonb']>;
  images?: InputMaybe<Scalars['jsonb']>;
  layout_data?: InputMaybe<Scalars['jsonb']>;
  social_media?: InputMaybe<Scalars['jsonb']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Listing_Avg_Fields = {
  __typename?: 'listing_avg_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "listing". All fields are combined with a logical 'AND'. */
export type Listing_Bool_Exp = {
  _and?: InputMaybe<Array<Listing_Bool_Exp>>;
  _not?: InputMaybe<Listing_Bool_Exp>;
  _or?: InputMaybe<Array<Listing_Bool_Exp>>;
  booking_links?: InputMaybe<Jsonb_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Jsonb_Comparison_Exp>;
  business_hours?: InputMaybe<Jsonb_Comparison_Exp>;
  business_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  is_island_original?: InputMaybe<Boolean_Comparison_Exp>;
  island?: InputMaybe<String_Comparison_Exp>;
  lat_lng?: InputMaybe<Point_Comparison_Exp>;
  layout_data?: InputMaybe<Jsonb_Comparison_Exp>;
  listing_category_tags?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
  listing_category_tags_aggregate?: InputMaybe<Listing_Category_Tag_Aggregate_Bool_Exp>;
  live?: InputMaybe<Boolean_Comparison_Exp>;
  main_category_id?: InputMaybe<Int_Comparison_Exp>;
  old_id?: InputMaybe<String_Comparison_Exp>;
  paid_until?: InputMaybe<Timestamptz_Comparison_Exp>;
  permalink?: InputMaybe<String_Comparison_Exp>;
  primary_address?: InputMaybe<String_Comparison_Exp>;
  primary_email?: InputMaybe<String_Comparison_Exp>;
  primary_phone?: InputMaybe<String_Comparison_Exp>;
  primary_web_url?: InputMaybe<String_Comparison_Exp>;
  promo_code_count?: InputMaybe<Int_Comparison_Exp>;
  promo_code_visitor_hook?: InputMaybe<String_Comparison_Exp>;
  promo_codes?: InputMaybe<Promo_Code_Bool_Exp>;
  promo_codes_aggregate?: InputMaybe<Promo_Code_Aggregate_Bool_Exp>;
  promoted?: InputMaybe<Boolean_Comparison_Exp>;
  rich_description?: InputMaybe<String_Comparison_Exp>;
  slogan?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  social_media?: InputMaybe<Jsonb_Comparison_Exp>;
  this_week_recommended?: InputMaybe<Boolean_Comparison_Exp>;
  tier?: InputMaybe<String_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  videos?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** join table for listings and category_tags */
export type Listing_Category_Tag = {
  __typename?: 'listing_category_tag';
  /** An object relationship */
  category_tag: Category_Tag;
  category_tag_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  listing: Listing;
  listing_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "listing_category_tag" */
export type Listing_Category_Tag_Aggregate = {
  __typename?: 'listing_category_tag_aggregate';
  aggregate?: Maybe<Listing_Category_Tag_Aggregate_Fields>;
  nodes: Array<Listing_Category_Tag>;
};

export type Listing_Category_Tag_Aggregate_Bool_Exp = {
  count?: InputMaybe<Listing_Category_Tag_Aggregate_Bool_Exp_Count>;
};

export type Listing_Category_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "listing_category_tag" */
export type Listing_Category_Tag_Aggregate_Fields = {
  __typename?: 'listing_category_tag_aggregate_fields';
  avg?: Maybe<Listing_Category_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Listing_Category_Tag_Max_Fields>;
  min?: Maybe<Listing_Category_Tag_Min_Fields>;
  stddev?: Maybe<Listing_Category_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Listing_Category_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Listing_Category_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Listing_Category_Tag_Sum_Fields>;
  var_pop?: Maybe<Listing_Category_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Listing_Category_Tag_Var_Samp_Fields>;
  variance?: Maybe<Listing_Category_Tag_Variance_Fields>;
};


/** aggregate fields of "listing_category_tag" */
export type Listing_Category_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "listing_category_tag" */
export type Listing_Category_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Listing_Category_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Listing_Category_Tag_Max_Order_By>;
  min?: InputMaybe<Listing_Category_Tag_Min_Order_By>;
  stddev?: InputMaybe<Listing_Category_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Listing_Category_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Listing_Category_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Listing_Category_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Listing_Category_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Listing_Category_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Listing_Category_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "listing_category_tag" */
export type Listing_Category_Tag_Arr_Rel_Insert_Input = {
  data: Array<Listing_Category_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Listing_Category_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Listing_Category_Tag_Avg_Fields = {
  __typename?: 'listing_category_tag_avg_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Avg_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "listing_category_tag". All fields are combined with a logical 'AND'. */
export type Listing_Category_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Listing_Category_Tag_Bool_Exp>>;
  _not?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Listing_Category_Tag_Bool_Exp>>;
  category_tag?: InputMaybe<Category_Tag_Bool_Exp>;
  category_tag_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  listing?: InputMaybe<Listing_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "listing_category_tag" */
export enum Listing_Category_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListingCategoryTagPkey = 'listing_category_tag_pkey'
}

/** input type for incrementing numeric columns in table "listing_category_tag" */
export type Listing_Category_Tag_Inc_Input = {
  category_tag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  listing_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "listing_category_tag" */
export type Listing_Category_Tag_Insert_Input = {
  category_tag?: InputMaybe<Category_Tag_Obj_Rel_Insert_Input>;
  category_tag_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  listing?: InputMaybe<Listing_Obj_Rel_Insert_Input>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Listing_Category_Tag_Max_Fields = {
  __typename?: 'listing_category_tag_max_fields';
  category_tag_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  listing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Max_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Listing_Category_Tag_Min_Fields = {
  __typename?: 'listing_category_tag_min_fields';
  category_tag_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  listing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Min_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "listing_category_tag" */
export type Listing_Category_Tag_Mutation_Response = {
  __typename?: 'listing_category_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Listing_Category_Tag>;
};

/** on_conflict condition type for table "listing_category_tag" */
export type Listing_Category_Tag_On_Conflict = {
  constraint: Listing_Category_Tag_Constraint;
  update_columns?: Array<Listing_Category_Tag_Update_Column>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "listing_category_tag". */
export type Listing_Category_Tag_Order_By = {
  category_tag?: InputMaybe<Category_Tag_Order_By>;
  category_tag_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Listing_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: listing_category_tag */
export type Listing_Category_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "listing_category_tag" */
export enum Listing_Category_Tag_Select_Column {
  /** column name */
  CategoryTagId = 'category_tag_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "listing_category_tag" */
export type Listing_Category_Tag_Set_Input = {
  category_tag_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Listing_Category_Tag_Stddev_Fields = {
  __typename?: 'listing_category_tag_stddev_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Stddev_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Listing_Category_Tag_Stddev_Pop_Fields = {
  __typename?: 'listing_category_tag_stddev_pop_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Stddev_Pop_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Listing_Category_Tag_Stddev_Samp_Fields = {
  __typename?: 'listing_category_tag_stddev_samp_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Stddev_Samp_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "listing_category_tag" */
export type Listing_Category_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Listing_Category_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Listing_Category_Tag_Stream_Cursor_Value_Input = {
  category_tag_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Listing_Category_Tag_Sum_Fields = {
  __typename?: 'listing_category_tag_sum_fields';
  category_tag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listing_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Sum_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** update columns of table "listing_category_tag" */
export enum Listing_Category_Tag_Update_Column {
  /** column name */
  CategoryTagId = 'category_tag_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Listing_Category_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Listing_Category_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Listing_Category_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Listing_Category_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Listing_Category_Tag_Var_Pop_Fields = {
  __typename?: 'listing_category_tag_var_pop_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Var_Pop_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Listing_Category_Tag_Var_Samp_Fields = {
  __typename?: 'listing_category_tag_var_samp_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Var_Samp_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Listing_Category_Tag_Variance_Fields = {
  __typename?: 'listing_category_tag_variance_fields';
  category_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "listing_category_tag" */
export type Listing_Category_Tag_Variance_Order_By = {
  category_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "listing" */
export enum Listing_Constraint {
  /** unique or primary key constraint on columns "id" */
  ListingIdKey = 'listing_id_key',
  /** unique or primary key constraint on columns "id" */
  ListingPkey = 'listing_pkey',
  /** unique or primary key constraint on columns "slug" */
  ListingSlugKey = 'listing_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Listing_Delete_At_Path_Input = {
  booking_links?: InputMaybe<Array<Scalars['String']>>;
  breadcrumbs?: InputMaybe<Array<Scalars['String']>>;
  business_hours?: InputMaybe<Array<Scalars['String']>>;
  images?: InputMaybe<Array<Scalars['String']>>;
  layout_data?: InputMaybe<Array<Scalars['String']>>;
  social_media?: InputMaybe<Array<Scalars['String']>>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Listing_Delete_Elem_Input = {
  booking_links?: InputMaybe<Scalars['Int']>;
  breadcrumbs?: InputMaybe<Scalars['Int']>;
  business_hours?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['Int']>;
  layout_data?: InputMaybe<Scalars['Int']>;
  social_media?: InputMaybe<Scalars['Int']>;
  videos?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Listing_Delete_Key_Input = {
  booking_links?: InputMaybe<Scalars['String']>;
  breadcrumbs?: InputMaybe<Scalars['String']>;
  business_hours?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Scalars['String']>;
  layout_data?: InputMaybe<Scalars['String']>;
  social_media?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "listing" */
export type Listing_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  main_category_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "listing" */
export type Listing_Insert_Input = {
  booking_links?: InputMaybe<Scalars['jsonb']>;
  breadcrumbs?: InputMaybe<Scalars['jsonb']>;
  business_hours?: InputMaybe<Scalars['jsonb']>;
  business_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['jsonb']>;
  is_island_original?: InputMaybe<Scalars['Boolean']>;
  island?: InputMaybe<Scalars['String']>;
  lat_lng?: InputMaybe<Scalars['point']>;
  layout_data?: InputMaybe<Scalars['jsonb']>;
  listing_category_tags?: InputMaybe<Listing_Category_Tag_Arr_Rel_Insert_Input>;
  live?: InputMaybe<Scalars['Boolean']>;
  main_category_id?: InputMaybe<Scalars['Int']>;
  old_id?: InputMaybe<Scalars['String']>;
  paid_until?: InputMaybe<Scalars['timestamptz']>;
  primary_address?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  primary_web_url?: InputMaybe<Scalars['String']>;
  promo_code_visitor_hook?: InputMaybe<Scalars['String']>;
  promo_codes?: InputMaybe<Promo_Code_Arr_Rel_Insert_Input>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  rich_description?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  social_media?: InputMaybe<Scalars['jsonb']>;
  this_week_recommended?: InputMaybe<Scalars['Boolean']>;
  tier?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Listing_Max_Fields = {
  __typename?: 'listing_max_fields';
  business_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  island?: Maybe<Scalars['String']>;
  main_category_id?: Maybe<Scalars['Int']>;
  old_id?: Maybe<Scalars['String']>;
  paid_until?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "permalink_for_listing" */
  permalink?: Maybe<Scalars['String']>;
  primary_address?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  primary_web_url?: Maybe<Scalars['String']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
  promo_code_visitor_hook?: Maybe<Scalars['String']>;
  rich_description?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Listing_Min_Fields = {
  __typename?: 'listing_min_fields';
  business_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  island?: Maybe<Scalars['String']>;
  main_category_id?: Maybe<Scalars['Int']>;
  old_id?: Maybe<Scalars['String']>;
  paid_until?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "permalink_for_listing" */
  permalink?: Maybe<Scalars['String']>;
  primary_address?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  primary_web_url?: Maybe<Scalars['String']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
  promo_code_visitor_hook?: Maybe<Scalars['String']>;
  rich_description?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "listing" */
export type Listing_Mutation_Response = {
  __typename?: 'listing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Listing>;
};

/** input type for inserting object relation for remote table "listing" */
export type Listing_Obj_Rel_Insert_Input = {
  data: Listing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Listing_On_Conflict>;
};

/** on_conflict condition type for table "listing" */
export type Listing_On_Conflict = {
  constraint: Listing_Constraint;
  update_columns?: Array<Listing_Update_Column>;
  where?: InputMaybe<Listing_Bool_Exp>;
};

/** Ordering options when selecting data from "listing". */
export type Listing_Order_By = {
  booking_links?: InputMaybe<Order_By>;
  breadcrumbs?: InputMaybe<Order_By>;
  business_hours?: InputMaybe<Order_By>;
  business_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  is_island_original?: InputMaybe<Order_By>;
  island?: InputMaybe<Order_By>;
  lat_lng?: InputMaybe<Order_By>;
  layout_data?: InputMaybe<Order_By>;
  listing_category_tags_aggregate?: InputMaybe<Listing_Category_Tag_Aggregate_Order_By>;
  live?: InputMaybe<Order_By>;
  main_category_id?: InputMaybe<Order_By>;
  old_id?: InputMaybe<Order_By>;
  paid_until?: InputMaybe<Order_By>;
  permalink?: InputMaybe<Order_By>;
  primary_address?: InputMaybe<Order_By>;
  primary_email?: InputMaybe<Order_By>;
  primary_phone?: InputMaybe<Order_By>;
  primary_web_url?: InputMaybe<Order_By>;
  promo_code_count?: InputMaybe<Order_By>;
  promo_code_visitor_hook?: InputMaybe<Order_By>;
  promo_codes_aggregate?: InputMaybe<Promo_Code_Aggregate_Order_By>;
  promoted?: InputMaybe<Order_By>;
  rich_description?: InputMaybe<Order_By>;
  slogan?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  social_media?: InputMaybe<Order_By>;
  this_week_recommended?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  videos?: InputMaybe<Order_By>;
};

/** primary key columns input for table: listing */
export type Listing_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Listing_Prepend_Input = {
  booking_links?: InputMaybe<Scalars['jsonb']>;
  breadcrumbs?: InputMaybe<Scalars['jsonb']>;
  business_hours?: InputMaybe<Scalars['jsonb']>;
  images?: InputMaybe<Scalars['jsonb']>;
  layout_data?: InputMaybe<Scalars['jsonb']>;
  social_media?: InputMaybe<Scalars['jsonb']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "listing" */
export enum Listing_Select_Column {
  /** column name */
  BookingLinks = 'booking_links',
  /** column name */
  Breadcrumbs = 'breadcrumbs',
  /** column name */
  BusinessHours = 'business_hours',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsIslandOriginal = 'is_island_original',
  /** column name */
  Island = 'island',
  /** column name */
  LatLng = 'lat_lng',
  /** column name */
  LayoutData = 'layout_data',
  /** column name */
  Live = 'live',
  /** column name */
  MainCategoryId = 'main_category_id',
  /** column name */
  OldId = 'old_id',
  /** column name */
  PaidUntil = 'paid_until',
  /** column name */
  PrimaryAddress = 'primary_address',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  PrimaryWebUrl = 'primary_web_url',
  /** column name */
  PromoCodeVisitorHook = 'promo_code_visitor_hook',
  /** column name */
  Promoted = 'promoted',
  /** column name */
  RichDescription = 'rich_description',
  /** column name */
  Slogan = 'slogan',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialMedia = 'social_media',
  /** column name */
  ThisWeekRecommended = 'this_week_recommended',
  /** column name */
  Tier = 'tier',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Videos = 'videos'
}

/** input type for updating data in table "listing" */
export type Listing_Set_Input = {
  booking_links?: InputMaybe<Scalars['jsonb']>;
  breadcrumbs?: InputMaybe<Scalars['jsonb']>;
  business_hours?: InputMaybe<Scalars['jsonb']>;
  business_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['jsonb']>;
  is_island_original?: InputMaybe<Scalars['Boolean']>;
  island?: InputMaybe<Scalars['String']>;
  lat_lng?: InputMaybe<Scalars['point']>;
  layout_data?: InputMaybe<Scalars['jsonb']>;
  live?: InputMaybe<Scalars['Boolean']>;
  main_category_id?: InputMaybe<Scalars['Int']>;
  old_id?: InputMaybe<Scalars['String']>;
  paid_until?: InputMaybe<Scalars['timestamptz']>;
  primary_address?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  primary_web_url?: InputMaybe<Scalars['String']>;
  promo_code_visitor_hook?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  rich_description?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  social_media?: InputMaybe<Scalars['jsonb']>;
  this_week_recommended?: InputMaybe<Scalars['Boolean']>;
  tier?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Listing_Stddev_Fields = {
  __typename?: 'listing_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_pop on columns */
export type Listing_Stddev_Pop_Fields = {
  __typename?: 'listing_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_samp on columns */
export type Listing_Stddev_Samp_Fields = {
  __typename?: 'listing_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "listing" */
export type Listing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Listing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Listing_Stream_Cursor_Value_Input = {
  booking_links?: InputMaybe<Scalars['jsonb']>;
  breadcrumbs?: InputMaybe<Scalars['jsonb']>;
  business_hours?: InputMaybe<Scalars['jsonb']>;
  business_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Scalars['jsonb']>;
  is_island_original?: InputMaybe<Scalars['Boolean']>;
  island?: InputMaybe<Scalars['String']>;
  lat_lng?: InputMaybe<Scalars['point']>;
  layout_data?: InputMaybe<Scalars['jsonb']>;
  live?: InputMaybe<Scalars['Boolean']>;
  main_category_id?: InputMaybe<Scalars['Int']>;
  old_id?: InputMaybe<Scalars['String']>;
  paid_until?: InputMaybe<Scalars['timestamptz']>;
  primary_address?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  primary_web_url?: InputMaybe<Scalars['String']>;
  promo_code_visitor_hook?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  rich_description?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  social_media?: InputMaybe<Scalars['jsonb']>;
  this_week_recommended?: InputMaybe<Scalars['Boolean']>;
  tier?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Listing_Sum_Fields = {
  __typename?: 'listing_sum_fields';
  id?: Maybe<Scalars['Int']>;
  main_category_id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "listing" */
export enum Listing_Update_Column {
  /** column name */
  BookingLinks = 'booking_links',
  /** column name */
  Breadcrumbs = 'breadcrumbs',
  /** column name */
  BusinessHours = 'business_hours',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsIslandOriginal = 'is_island_original',
  /** column name */
  Island = 'island',
  /** column name */
  LatLng = 'lat_lng',
  /** column name */
  LayoutData = 'layout_data',
  /** column name */
  Live = 'live',
  /** column name */
  MainCategoryId = 'main_category_id',
  /** column name */
  OldId = 'old_id',
  /** column name */
  PaidUntil = 'paid_until',
  /** column name */
  PrimaryAddress = 'primary_address',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  PrimaryWebUrl = 'primary_web_url',
  /** column name */
  PromoCodeVisitorHook = 'promo_code_visitor_hook',
  /** column name */
  Promoted = 'promoted',
  /** column name */
  RichDescription = 'rich_description',
  /** column name */
  Slogan = 'slogan',
  /** column name */
  Slug = 'slug',
  /** column name */
  SocialMedia = 'social_media',
  /** column name */
  ThisWeekRecommended = 'this_week_recommended',
  /** column name */
  Tier = 'tier',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Videos = 'videos'
}

export type Listing_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Listing_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Listing_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Listing_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Listing_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Listing_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Listing_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Listing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Listing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Listing_Var_Pop_Fields = {
  __typename?: 'listing_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** aggregate var_samp on columns */
export type Listing_Var_Samp_Fields = {
  __typename?: 'listing_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** aggregate variance on columns */
export type Listing_Variance_Fields = {
  __typename?: 'listing_variance_fields';
  id?: Maybe<Scalars['Float']>;
  main_category_id?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "promo_code_count_for_listing" */
  promo_code_count?: Maybe<Scalars['Int']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "auth.oauth2_auth_requests" */
  deleteAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>;
  /** delete data from the table: "auth.oauth2_auth_requests" */
  deleteAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>;
  /** delete single row from the table: "auth.oauth2_authorization_codes" */
  deleteAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>;
  /** delete data from the table: "auth.oauth2_authorization_codes" */
  deleteAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>;
  /** delete single row from the table: "auth.oauth2_clients" */
  deleteAuthOauth2Client?: Maybe<AuthOauth2Clients>;
  /** delete data from the table: "auth.oauth2_clients" */
  deleteAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>;
  /** delete single row from the table: "auth.oauth2_refresh_tokens" */
  deleteAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>;
  /** delete data from the table: "auth.oauth2_refresh_tokens" */
  deleteAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "ad" */
  delete_ad?: Maybe<Ad_Mutation_Response>;
  /** delete single row from the table: "ad" */
  delete_ad_by_pk?: Maybe<Ad>;
  /** delete data from the table: "ad_cycle" */
  delete_ad_cycle?: Maybe<Ad_Cycle_Mutation_Response>;
  /** delete single row from the table: "ad_cycle" */
  delete_ad_cycle_by_pk?: Maybe<Ad_Cycle>;
  /** delete data from the table: "ad_event" */
  delete_ad_event?: Maybe<Ad_Event_Mutation_Response>;
  /** delete single row from the table: "ad_event" */
  delete_ad_event_by_pk?: Maybe<Ad_Event>;
  /** delete data from the table: "category_tag" */
  delete_category_tag?: Maybe<Category_Tag_Mutation_Response>;
  /** delete single row from the table: "category_tag" */
  delete_category_tag_by_pk?: Maybe<Category_Tag>;
  /** delete data from the table: "communication_opt_in" */
  delete_communication_opt_in?: Maybe<Communication_Opt_In_Mutation_Response>;
  /** delete single row from the table: "communication_opt_in" */
  delete_communication_opt_in_by_pk?: Maybe<Communication_Opt_In>;
  /** delete data from the table: "image" */
  delete_image?: Maybe<Image_Mutation_Response>;
  /** delete single row from the table: "image" */
  delete_image_by_pk?: Maybe<Image>;
  /** delete data from the table: "listing" */
  delete_listing?: Maybe<Listing_Mutation_Response>;
  /** delete single row from the table: "listing" */
  delete_listing_by_pk?: Maybe<Listing>;
  /** delete data from the table: "listing_category_tag" */
  delete_listing_category_tag?: Maybe<Listing_Category_Tag_Mutation_Response>;
  /** delete single row from the table: "listing_category_tag" */
  delete_listing_category_tag_by_pk?: Maybe<Listing_Category_Tag>;
  /** delete data from the table: "promo_code" */
  delete_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** delete single row from the table: "promo_code" */
  delete_promo_code_by_pk?: Maybe<Promo_Code>;
  /** delete data from the table: "visitor_answer" */
  delete_visitor_answer?: Maybe<Visitor_Answer_Mutation_Response>;
  /** delete single row from the table: "visitor_answer" */
  delete_visitor_answer_by_pk?: Maybe<Visitor_Answer>;
  /** delete data from the table: "visitor_question" */
  delete_visitor_question?: Maybe<Visitor_Question_Mutation_Response>;
  /** delete single row from the table: "visitor_question" */
  delete_visitor_question_by_pk?: Maybe<Visitor_Question>;
  /** insert a single row into the table: "auth.oauth2_auth_requests" */
  insertAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>;
  /** insert data into the table: "auth.oauth2_auth_requests" */
  insertAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>;
  /** insert a single row into the table: "auth.oauth2_authorization_codes" */
  insertAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>;
  /** insert data into the table: "auth.oauth2_authorization_codes" */
  insertAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>;
  /** insert a single row into the table: "auth.oauth2_clients" */
  insertAuthOauth2Client?: Maybe<AuthOauth2Clients>;
  /** insert data into the table: "auth.oauth2_clients" */
  insertAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>;
  /** insert a single row into the table: "auth.oauth2_refresh_tokens" */
  insertAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>;
  /** insert data into the table: "auth.oauth2_refresh_tokens" */
  insertAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "ad" */
  insert_ad?: Maybe<Ad_Mutation_Response>;
  /** insert data into the table: "ad_cycle" */
  insert_ad_cycle?: Maybe<Ad_Cycle_Mutation_Response>;
  /** insert a single row into the table: "ad_cycle" */
  insert_ad_cycle_one?: Maybe<Ad_Cycle>;
  /** insert data into the table: "ad_event" */
  insert_ad_event?: Maybe<Ad_Event_Mutation_Response>;
  /** insert a single row into the table: "ad_event" */
  insert_ad_event_one?: Maybe<Ad_Event>;
  /** insert a single row into the table: "ad" */
  insert_ad_one?: Maybe<Ad>;
  /** insert data into the table: "category_tag" */
  insert_category_tag?: Maybe<Category_Tag_Mutation_Response>;
  /** insert a single row into the table: "category_tag" */
  insert_category_tag_one?: Maybe<Category_Tag>;
  /** insert data into the table: "communication_opt_in" */
  insert_communication_opt_in?: Maybe<Communication_Opt_In_Mutation_Response>;
  /** insert a single row into the table: "communication_opt_in" */
  insert_communication_opt_in_one?: Maybe<Communication_Opt_In>;
  /** insert data into the table: "image" */
  insert_image?: Maybe<Image_Mutation_Response>;
  /** insert a single row into the table: "image" */
  insert_image_one?: Maybe<Image>;
  /** insert data into the table: "listing" */
  insert_listing?: Maybe<Listing_Mutation_Response>;
  /** insert data into the table: "listing_category_tag" */
  insert_listing_category_tag?: Maybe<Listing_Category_Tag_Mutation_Response>;
  /** insert a single row into the table: "listing_category_tag" */
  insert_listing_category_tag_one?: Maybe<Listing_Category_Tag>;
  /** insert a single row into the table: "listing" */
  insert_listing_one?: Maybe<Listing>;
  /** insert data into the table: "promo_code" */
  insert_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** insert a single row into the table: "promo_code" */
  insert_promo_code_one?: Maybe<Promo_Code>;
  /** insert data into the table: "visitor_answer" */
  insert_visitor_answer?: Maybe<Visitor_Answer_Mutation_Response>;
  /** insert a single row into the table: "visitor_answer" */
  insert_visitor_answer_one?: Maybe<Visitor_Answer>;
  /** insert data into the table: "visitor_question" */
  insert_visitor_question?: Maybe<Visitor_Question_Mutation_Response>;
  /** insert a single row into the table: "visitor_question" */
  insert_visitor_question_one?: Maybe<Visitor_Question>;
  /** update single row of the table: "auth.oauth2_auth_requests" */
  updateAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>;
  /** update data of the table: "auth.oauth2_auth_requests" */
  updateAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>;
  /** update single row of the table: "auth.oauth2_authorization_codes" */
  updateAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>;
  /** update data of the table: "auth.oauth2_authorization_codes" */
  updateAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>;
  /** update single row of the table: "auth.oauth2_clients" */
  updateAuthOauth2Client?: Maybe<AuthOauth2Clients>;
  /** update data of the table: "auth.oauth2_clients" */
  updateAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>;
  /** update single row of the table: "auth.oauth2_refresh_tokens" */
  updateAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>;
  /** update data of the table: "auth.oauth2_refresh_tokens" */
  updateAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "ad" */
  update_ad?: Maybe<Ad_Mutation_Response>;
  /** update single row of the table: "ad" */
  update_ad_by_pk?: Maybe<Ad>;
  /** update data of the table: "ad_cycle" */
  update_ad_cycle?: Maybe<Ad_Cycle_Mutation_Response>;
  /** update single row of the table: "ad_cycle" */
  update_ad_cycle_by_pk?: Maybe<Ad_Cycle>;
  /** update multiples rows of table: "ad_cycle" */
  update_ad_cycle_many?: Maybe<Array<Maybe<Ad_Cycle_Mutation_Response>>>;
  /** update data of the table: "ad_event" */
  update_ad_event?: Maybe<Ad_Event_Mutation_Response>;
  /** update single row of the table: "ad_event" */
  update_ad_event_by_pk?: Maybe<Ad_Event>;
  /** update multiples rows of table: "ad_event" */
  update_ad_event_many?: Maybe<Array<Maybe<Ad_Event_Mutation_Response>>>;
  /** update multiples rows of table: "ad" */
  update_ad_many?: Maybe<Array<Maybe<Ad_Mutation_Response>>>;
  /** update multiples rows of table: "auth.oauth2_auth_requests" */
  update_authOauth2AuthRequests_many?: Maybe<Array<Maybe<AuthOauth2AuthRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.oauth2_authorization_codes" */
  update_authOauth2AuthorizationCodes_many?: Maybe<Array<Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.oauth2_clients" */
  update_authOauth2Clients_many?: Maybe<Array<Maybe<AuthOauth2Clients_Mutation_Response>>>;
  /** update multiples rows of table: "auth.oauth2_refresh_tokens" */
  update_authOauth2RefreshTokens_many?: Maybe<Array<Maybe<AuthOauth2RefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "category_tag" */
  update_category_tag?: Maybe<Category_Tag_Mutation_Response>;
  /** update single row of the table: "category_tag" */
  update_category_tag_by_pk?: Maybe<Category_Tag>;
  /** update multiples rows of table: "category_tag" */
  update_category_tag_many?: Maybe<Array<Maybe<Category_Tag_Mutation_Response>>>;
  /** update data of the table: "communication_opt_in" */
  update_communication_opt_in?: Maybe<Communication_Opt_In_Mutation_Response>;
  /** update single row of the table: "communication_opt_in" */
  update_communication_opt_in_by_pk?: Maybe<Communication_Opt_In>;
  /** update multiples rows of table: "communication_opt_in" */
  update_communication_opt_in_many?: Maybe<Array<Maybe<Communication_Opt_In_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "image" */
  update_image?: Maybe<Image_Mutation_Response>;
  /** update single row of the table: "image" */
  update_image_by_pk?: Maybe<Image>;
  /** update multiples rows of table: "image" */
  update_image_many?: Maybe<Array<Maybe<Image_Mutation_Response>>>;
  /** update data of the table: "listing" */
  update_listing?: Maybe<Listing_Mutation_Response>;
  /** update single row of the table: "listing" */
  update_listing_by_pk?: Maybe<Listing>;
  /** update data of the table: "listing_category_tag" */
  update_listing_category_tag?: Maybe<Listing_Category_Tag_Mutation_Response>;
  /** update single row of the table: "listing_category_tag" */
  update_listing_category_tag_by_pk?: Maybe<Listing_Category_Tag>;
  /** update multiples rows of table: "listing_category_tag" */
  update_listing_category_tag_many?: Maybe<Array<Maybe<Listing_Category_Tag_Mutation_Response>>>;
  /** update multiples rows of table: "listing" */
  update_listing_many?: Maybe<Array<Maybe<Listing_Mutation_Response>>>;
  /** update data of the table: "promo_code" */
  update_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** update single row of the table: "promo_code" */
  update_promo_code_by_pk?: Maybe<Promo_Code>;
  /** update multiples rows of table: "promo_code" */
  update_promo_code_many?: Maybe<Array<Maybe<Promo_Code_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
  /** update data of the table: "visitor_answer" */
  update_visitor_answer?: Maybe<Visitor_Answer_Mutation_Response>;
  /** update single row of the table: "visitor_answer" */
  update_visitor_answer_by_pk?: Maybe<Visitor_Answer>;
  /** update multiples rows of table: "visitor_answer" */
  update_visitor_answer_many?: Maybe<Array<Maybe<Visitor_Answer_Mutation_Response>>>;
  /** update data of the table: "visitor_question" */
  update_visitor_question?: Maybe<Visitor_Question_Mutation_Response>;
  /** update single row of the table: "visitor_question" */
  update_visitor_question_by_pk?: Maybe<Visitor_Question>;
  /** update multiples rows of table: "visitor_question" */
  update_visitor_question_many?: Maybe<Array<Maybe<Visitor_Question_Mutation_Response>>>;
  /** Upload Image To Listing */
  uploadImage: UploadImagePayload;
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthRequestsArgs = {
  where: AuthOauth2AuthRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthorizationCodesArgs = {
  where: AuthOauth2AuthorizationCodes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2ClientArgs = {
  clientId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2ClientsArgs = {
  where: AuthOauth2Clients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthOauth2RefreshTokensArgs = {
  where: AuthOauth2RefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AdArgs = {
  where: Ad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_CycleArgs = {
  where: Ad_Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Cycle_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ad_EventArgs = {
  where: Ad_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ad_Event_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Category_TagArgs = {
  where: Category_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Communication_Opt_InArgs = {
  where: Communication_Opt_In_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Communication_Opt_In_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ImageArgs = {
  where: Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Image_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ListingArgs = {
  where: Listing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Listing_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Listing_Category_TagArgs = {
  where: Listing_Category_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Listing_Category_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Promo_CodeArgs = {
  where: Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Promo_Code_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Visitor_AnswerArgs = {
  where: Visitor_Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visitor_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Visitor_QuestionArgs = {
  where: Visitor_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visitor_Question_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthRequestArgs = {
  object: AuthOauth2AuthRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthRequestsArgs = {
  objects: Array<AuthOauth2AuthRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthorizationCodeArgs = {
  object: AuthOauth2AuthorizationCodes_Insert_Input;
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthorizationCodesArgs = {
  objects: Array<AuthOauth2AuthorizationCodes_Insert_Input>;
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2ClientArgs = {
  object: AuthOauth2Clients_Insert_Input;
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2ClientsArgs = {
  objects: Array<AuthOauth2Clients_Insert_Input>;
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2RefreshTokenArgs = {
  object: AuthOauth2RefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthOauth2RefreshTokensArgs = {
  objects: Array<AuthOauth2RefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AdArgs = {
  objects: Array<Ad_Insert_Input>;
  on_conflict?: InputMaybe<Ad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_CycleArgs = {
  objects: Array<Ad_Cycle_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Cycle_OneArgs = {
  object: Ad_Cycle_Insert_Input;
  on_conflict?: InputMaybe<Ad_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_EventArgs = {
  objects: Array<Ad_Event_Insert_Input>;
  on_conflict?: InputMaybe<Ad_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_Event_OneArgs = {
  object: Ad_Event_Insert_Input;
  on_conflict?: InputMaybe<Ad_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ad_OneArgs = {
  object: Ad_Insert_Input;
  on_conflict?: InputMaybe<Ad_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_TagArgs = {
  objects: Array<Category_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Category_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_Tag_OneArgs = {
  object: Category_Tag_Insert_Input;
  on_conflict?: InputMaybe<Category_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Communication_Opt_InArgs = {
  objects: Array<Communication_Opt_In_Insert_Input>;
  on_conflict?: InputMaybe<Communication_Opt_In_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Communication_Opt_In_OneArgs = {
  object: Communication_Opt_In_Insert_Input;
  on_conflict?: InputMaybe<Communication_Opt_In_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImageArgs = {
  objects: Array<Image_Insert_Input>;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_OneArgs = {
  object: Image_Insert_Input;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ListingArgs = {
  objects: Array<Listing_Insert_Input>;
  on_conflict?: InputMaybe<Listing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Listing_Category_TagArgs = {
  objects: Array<Listing_Category_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Listing_Category_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Listing_Category_Tag_OneArgs = {
  object: Listing_Category_Tag_Insert_Input;
  on_conflict?: InputMaybe<Listing_Category_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Listing_OneArgs = {
  object: Listing_Insert_Input;
  on_conflict?: InputMaybe<Listing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_CodeArgs = {
  objects: Array<Promo_Code_Insert_Input>;
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_Code_OneArgs = {
  object: Promo_Code_Insert_Input;
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visitor_AnswerArgs = {
  objects: Array<Visitor_Answer_Insert_Input>;
  on_conflict?: InputMaybe<Visitor_Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visitor_Answer_OneArgs = {
  object: Visitor_Answer_Insert_Input;
  on_conflict?: InputMaybe<Visitor_Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visitor_QuestionArgs = {
  objects: Array<Visitor_Question_Insert_Input>;
  on_conflict?: InputMaybe<Visitor_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visitor_Question_OneArgs = {
  object: Visitor_Question_Insert_Input;
  on_conflict?: InputMaybe<Visitor_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthRequestArgs = {
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>;
  pk_columns: AuthOauth2AuthRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthRequestsArgs = {
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>;
  where: AuthOauth2AuthRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthorizationCodeArgs = {
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>;
  pk_columns: AuthOauth2AuthorizationCodes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthorizationCodesArgs = {
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>;
  where: AuthOauth2AuthorizationCodes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2ClientArgs = {
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>;
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>;
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>;
  pk_columns: AuthOauth2Clients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2ClientsArgs = {
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>;
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>;
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>;
  where: AuthOauth2Clients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2RefreshTokenArgs = {
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>;
  pk_columns: AuthOauth2RefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthOauth2RefreshTokensArgs = {
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>;
  where: AuthOauth2RefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>;
  where: AuthRefreshTokenTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AdArgs = {
  _inc?: InputMaybe<Ad_Inc_Input>;
  _set?: InputMaybe<Ad_Set_Input>;
  where: Ad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_By_PkArgs = {
  _inc?: InputMaybe<Ad_Inc_Input>;
  _set?: InputMaybe<Ad_Set_Input>;
  pk_columns: Ad_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_CycleArgs = {
  _inc?: InputMaybe<Ad_Cycle_Inc_Input>;
  _set?: InputMaybe<Ad_Cycle_Set_Input>;
  where: Ad_Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Cycle_By_PkArgs = {
  _inc?: InputMaybe<Ad_Cycle_Inc_Input>;
  _set?: InputMaybe<Ad_Cycle_Set_Input>;
  pk_columns: Ad_Cycle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Cycle_ManyArgs = {
  updates: Array<Ad_Cycle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_EventArgs = {
  _inc?: InputMaybe<Ad_Event_Inc_Input>;
  _set?: InputMaybe<Ad_Event_Set_Input>;
  where: Ad_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Event_By_PkArgs = {
  _inc?: InputMaybe<Ad_Event_Inc_Input>;
  _set?: InputMaybe<Ad_Event_Set_Input>;
  pk_columns: Ad_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_Event_ManyArgs = {
  updates: Array<Ad_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ad_ManyArgs = {
  updates: Array<Ad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthOauth2AuthRequests_ManyArgs = {
  updates: Array<AuthOauth2AuthRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthOauth2AuthorizationCodes_ManyArgs = {
  updates: Array<AuthOauth2AuthorizationCodes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthOauth2Clients_ManyArgs = {
  updates: Array<AuthOauth2Clients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthOauth2RefreshTokens_ManyArgs = {
  updates: Array<AuthOauth2RefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Category_TagArgs = {
  _inc?: InputMaybe<Category_Tag_Inc_Input>;
  _set?: InputMaybe<Category_Tag_Set_Input>;
  where: Category_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Tag_By_PkArgs = {
  _inc?: InputMaybe<Category_Tag_Inc_Input>;
  _set?: InputMaybe<Category_Tag_Set_Input>;
  pk_columns: Category_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Tag_ManyArgs = {
  updates: Array<Category_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_Opt_InArgs = {
  _inc?: InputMaybe<Communication_Opt_In_Inc_Input>;
  _set?: InputMaybe<Communication_Opt_In_Set_Input>;
  where: Communication_Opt_In_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_Opt_In_By_PkArgs = {
  _inc?: InputMaybe<Communication_Opt_In_Inc_Input>;
  _set?: InputMaybe<Communication_Opt_In_Set_Input>;
  pk_columns: Communication_Opt_In_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_Opt_In_ManyArgs = {
  updates: Array<Communication_Opt_In_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ImageArgs = {
  _inc?: InputMaybe<Image_Inc_Input>;
  _set?: InputMaybe<Image_Set_Input>;
  where: Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_By_PkArgs = {
  _inc?: InputMaybe<Image_Inc_Input>;
  _set?: InputMaybe<Image_Set_Input>;
  pk_columns: Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_ManyArgs = {
  updates: Array<Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ListingArgs = {
  _append?: InputMaybe<Listing_Append_Input>;
  _delete_at_path?: InputMaybe<Listing_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Listing_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Listing_Delete_Key_Input>;
  _inc?: InputMaybe<Listing_Inc_Input>;
  _prepend?: InputMaybe<Listing_Prepend_Input>;
  _set?: InputMaybe<Listing_Set_Input>;
  where: Listing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Listing_By_PkArgs = {
  _append?: InputMaybe<Listing_Append_Input>;
  _delete_at_path?: InputMaybe<Listing_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Listing_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Listing_Delete_Key_Input>;
  _inc?: InputMaybe<Listing_Inc_Input>;
  _prepend?: InputMaybe<Listing_Prepend_Input>;
  _set?: InputMaybe<Listing_Set_Input>;
  pk_columns: Listing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Listing_Category_TagArgs = {
  _inc?: InputMaybe<Listing_Category_Tag_Inc_Input>;
  _set?: InputMaybe<Listing_Category_Tag_Set_Input>;
  where: Listing_Category_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Listing_Category_Tag_By_PkArgs = {
  _inc?: InputMaybe<Listing_Category_Tag_Inc_Input>;
  _set?: InputMaybe<Listing_Category_Tag_Set_Input>;
  pk_columns: Listing_Category_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Listing_Category_Tag_ManyArgs = {
  updates: Array<Listing_Category_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Listing_ManyArgs = {
  updates: Array<Listing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_CodeArgs = {
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  _set?: InputMaybe<Promo_Code_Set_Input>;
  where: Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_By_PkArgs = {
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  _set?: InputMaybe<Promo_Code_Set_Input>;
  pk_columns: Promo_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_ManyArgs = {
  updates: Array<Promo_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_AnswerArgs = {
  _append?: InputMaybe<Visitor_Answer_Append_Input>;
  _delete_at_path?: InputMaybe<Visitor_Answer_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visitor_Answer_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visitor_Answer_Delete_Key_Input>;
  _inc?: InputMaybe<Visitor_Answer_Inc_Input>;
  _prepend?: InputMaybe<Visitor_Answer_Prepend_Input>;
  _set?: InputMaybe<Visitor_Answer_Set_Input>;
  where: Visitor_Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_Answer_By_PkArgs = {
  _append?: InputMaybe<Visitor_Answer_Append_Input>;
  _delete_at_path?: InputMaybe<Visitor_Answer_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visitor_Answer_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visitor_Answer_Delete_Key_Input>;
  _inc?: InputMaybe<Visitor_Answer_Inc_Input>;
  _prepend?: InputMaybe<Visitor_Answer_Prepend_Input>;
  _set?: InputMaybe<Visitor_Answer_Set_Input>;
  pk_columns: Visitor_Answer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_Answer_ManyArgs = {
  updates: Array<Visitor_Answer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_QuestionArgs = {
  _append?: InputMaybe<Visitor_Question_Append_Input>;
  _delete_at_path?: InputMaybe<Visitor_Question_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visitor_Question_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visitor_Question_Delete_Key_Input>;
  _inc?: InputMaybe<Visitor_Question_Inc_Input>;
  _prepend?: InputMaybe<Visitor_Question_Prepend_Input>;
  _set?: InputMaybe<Visitor_Question_Set_Input>;
  where: Visitor_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_Question_By_PkArgs = {
  _append?: InputMaybe<Visitor_Question_Append_Input>;
  _delete_at_path?: InputMaybe<Visitor_Question_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Visitor_Question_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Visitor_Question_Delete_Key_Input>;
  _inc?: InputMaybe<Visitor_Question_Inc_Input>;
  _prepend?: InputMaybe<Visitor_Question_Prepend_Input>;
  _set?: InputMaybe<Visitor_Question_Set_Input>;
  pk_columns: Visitor_Question_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Visitor_Question_ManyArgs = {
  updates: Array<Visitor_Question_Updates>;
};


/** mutation root */
export type Mutation_RootUploadImageArgs = {
  destination?: InputMaybe<Scalars['String']>;
  entityId: Scalars['Int'];
  fix?: InputMaybe<Scalars['Boolean']>;
  src: Scalars['String'];
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']>;
  _gt?: InputMaybe<Scalars['point']>;
  _gte?: InputMaybe<Scalars['point']>;
  _in?: InputMaybe<Array<Scalars['point']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['point']>;
  _lte?: InputMaybe<Scalars['point']>;
  _neq?: InputMaybe<Scalars['point']>;
  _nin?: InputMaybe<Array<Scalars['point']>>;
};

/** simple promo codes for business listing partners */
export type Promo_Code = {
  __typename?: 'promo_code';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  expiration?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  /** An object relationship */
  listing: Listing;
  listing_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "promo_code" */
export type Promo_Code_Aggregate = {
  __typename?: 'promo_code_aggregate';
  aggregate?: Maybe<Promo_Code_Aggregate_Fields>;
  nodes: Array<Promo_Code>;
};

export type Promo_Code_Aggregate_Bool_Exp = {
  count?: InputMaybe<Promo_Code_Aggregate_Bool_Exp_Count>;
};

export type Promo_Code_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Promo_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Promo_Code_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "promo_code" */
export type Promo_Code_Aggregate_Fields = {
  __typename?: 'promo_code_aggregate_fields';
  avg?: Maybe<Promo_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Promo_Code_Max_Fields>;
  min?: Maybe<Promo_Code_Min_Fields>;
  stddev?: Maybe<Promo_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Promo_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Promo_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Promo_Code_Sum_Fields>;
  var_pop?: Maybe<Promo_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Promo_Code_Var_Samp_Fields>;
  variance?: Maybe<Promo_Code_Variance_Fields>;
};


/** aggregate fields of "promo_code" */
export type Promo_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Promo_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "promo_code" */
export type Promo_Code_Aggregate_Order_By = {
  avg?: InputMaybe<Promo_Code_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Promo_Code_Max_Order_By>;
  min?: InputMaybe<Promo_Code_Min_Order_By>;
  stddev?: InputMaybe<Promo_Code_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Promo_Code_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Promo_Code_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Promo_Code_Sum_Order_By>;
  var_pop?: InputMaybe<Promo_Code_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Promo_Code_Var_Samp_Order_By>;
  variance?: InputMaybe<Promo_Code_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "promo_code" */
export type Promo_Code_Arr_Rel_Insert_Input = {
  data: Array<Promo_Code_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};

/** aggregate avg on columns */
export type Promo_Code_Avg_Fields = {
  __typename?: 'promo_code_avg_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "promo_code" */
export type Promo_Code_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "promo_code". All fields are combined with a logical 'AND'. */
export type Promo_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Promo_Code_Bool_Exp>>;
  _not?: InputMaybe<Promo_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Promo_Code_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  listing?: InputMaybe<Listing_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "promo_code" */
export enum Promo_Code_Constraint {
  /** unique or primary key constraint on columns "id" */
  PromoCodePkey = 'promo_code_pkey'
}

/** input type for incrementing numeric columns in table "promo_code" */
export type Promo_Code_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  listing_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "promo_code" */
export type Promo_Code_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  listing?: InputMaybe<Listing_Obj_Rel_Insert_Input>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Promo_Code_Max_Fields = {
  __typename?: 'promo_code_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  listing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "promo_code" */
export type Promo_Code_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Promo_Code_Min_Fields = {
  __typename?: 'promo_code_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  listing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "promo_code" */
export type Promo_Code_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "promo_code" */
export type Promo_Code_Mutation_Response = {
  __typename?: 'promo_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Promo_Code>;
};

/** on_conflict condition type for table "promo_code" */
export type Promo_Code_On_Conflict = {
  constraint: Promo_Code_Constraint;
  update_columns?: Array<Promo_Code_Update_Column>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "promo_code". */
export type Promo_Code_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  listing?: InputMaybe<Listing_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: promo_code */
export type Promo_Code_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "promo_code" */
export enum Promo_Code_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "promo_code" */
export type Promo_Code_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Promo_Code_Stddev_Fields = {
  __typename?: 'promo_code_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "promo_code" */
export type Promo_Code_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Promo_Code_Stddev_Pop_Fields = {
  __typename?: 'promo_code_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "promo_code" */
export type Promo_Code_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Promo_Code_Stddev_Samp_Fields = {
  __typename?: 'promo_code_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "promo_code" */
export type Promo_Code_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "promo_code" */
export type Promo_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Promo_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Promo_Code_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  listing_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Promo_Code_Sum_Fields = {
  __typename?: 'promo_code_sum_fields';
  id?: Maybe<Scalars['Int']>;
  listing_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "promo_code" */
export type Promo_Code_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** update columns of table "promo_code" */
export enum Promo_Code_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Promo_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Promo_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Promo_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Promo_Code_Var_Pop_Fields = {
  __typename?: 'promo_code_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "promo_code" */
export type Promo_Code_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Promo_Code_Var_Samp_Fields = {
  __typename?: 'promo_code_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "promo_code" */
export type Promo_Code_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Promo_Code_Variance_Fields = {
  __typename?: 'promo_code_variance_fields';
  id?: Maybe<Scalars['Float']>;
  listing_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "promo_code" */
export type Promo_Code_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "ad" */
  ad: Array<Ad>;
  /** fetch aggregated fields from the table: "ad" */
  ad_aggregate: Ad_Aggregate;
  /** fetch data from the table: "ad" using primary key columns */
  ad_by_pk?: Maybe<Ad>;
  /** fetch data from the table: "ad_cycle" */
  ad_cycle: Array<Ad_Cycle>;
  /** fetch aggregated fields from the table: "ad_cycle" */
  ad_cycle_aggregate: Ad_Cycle_Aggregate;
  /** fetch data from the table: "ad_cycle" using primary key columns */
  ad_cycle_by_pk?: Maybe<Ad_Cycle>;
  /** fetch data from the table: "ad_event" */
  ad_event: Array<Ad_Event>;
  /** fetch aggregated fields from the table: "ad_event" */
  ad_event_aggregate: Ad_Event_Aggregate;
  /** fetch data from the table: "ad_event" using primary key columns */
  ad_event_by_pk?: Maybe<Ad_Event>;
  /** fetch data from the table: "auth.oauth2_auth_requests" using primary key columns */
  authOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>;
  /** fetch data from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests: Array<AuthOauth2AuthRequests>;
  /** fetch aggregated fields from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequestsAggregate: AuthOauth2AuthRequests_Aggregate;
  /** fetch data from the table: "auth.oauth2_authorization_codes" using primary key columns */
  authOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>;
  /** fetch data from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes: Array<AuthOauth2AuthorizationCodes>;
  /** fetch aggregated fields from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodesAggregate: AuthOauth2AuthorizationCodes_Aggregate;
  /** fetch data from the table: "auth.oauth2_clients" using primary key columns */
  authOauth2Client?: Maybe<AuthOauth2Clients>;
  /** fetch data from the table: "auth.oauth2_clients" */
  authOauth2Clients: Array<AuthOauth2Clients>;
  /** fetch aggregated fields from the table: "auth.oauth2_clients" */
  authOauth2ClientsAggregate: AuthOauth2Clients_Aggregate;
  /** fetch data from the table: "auth.oauth2_refresh_tokens" using primary key columns */
  authOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>;
  /** fetch data from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens: Array<AuthOauth2RefreshTokens>;
  /** fetch aggregated fields from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokensAggregate: AuthOauth2RefreshTokens_Aggregate;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "category_tag" */
  category_tag: Array<Category_Tag>;
  /** fetch aggregated fields from the table: "category_tag" */
  category_tag_aggregate: Category_Tag_Aggregate;
  /** fetch data from the table: "category_tag" using primary key columns */
  category_tag_by_pk?: Maybe<Category_Tag>;
  /** check if an image exists in duda (theoretically) */
  checkImage: CheckImagePayload;
  /** fetch data from the table: "communication_opt_in" */
  communication_opt_in: Array<Communication_Opt_In>;
  /** fetch aggregated fields from the table: "communication_opt_in" */
  communication_opt_in_aggregate: Communication_Opt_In_Aggregate;
  /** fetch data from the table: "communication_opt_in" using primary key columns */
  communication_opt_in_by_pk?: Maybe<Communication_Opt_In>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  fuzzy_search_categories: Array<Fuzzy_Category_Tag>;
  fuzzy_search_listings: Array<Fuzzy_Listing>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch aggregated fields from the table: "image" */
  image_aggregate: Image_Aggregate;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table: "listing" */
  listing: Array<Listing>;
  /** fetch aggregated fields from the table: "listing" */
  listing_aggregate: Listing_Aggregate;
  /** fetch data from the table: "listing" using primary key columns */
  listing_by_pk?: Maybe<Listing>;
  /** fetch data from the table: "listing_category_tag" */
  listing_category_tag: Array<Listing_Category_Tag>;
  /** fetch aggregated fields from the table: "listing_category_tag" */
  listing_category_tag_aggregate: Listing_Category_Tag_Aggregate;
  /** fetch data from the table: "listing_category_tag" using primary key columns */
  listing_category_tag_by_pk?: Maybe<Listing_Category_Tag>;
  /** fetch data from the table: "promo_code" */
  promo_code: Array<Promo_Code>;
  /** fetch aggregated fields from the table: "promo_code" */
  promo_code_aggregate: Promo_Code_Aggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promo_code_by_pk?: Maybe<Promo_Code>;
  /** execute function "search_listings" which returns "listing" */
  search_listings: Array<Listing>;
  /** execute function "search_listings" and query aggregates on result of table type "listing" */
  search_listings_aggregate: Listing_Aggregate;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visitor_answer" */
  visitor_answer: Array<Visitor_Answer>;
  /** fetch aggregated fields from the table: "visitor_answer" */
  visitor_answer_aggregate: Visitor_Answer_Aggregate;
  /** fetch data from the table: "visitor_answer" using primary key columns */
  visitor_answer_by_pk?: Maybe<Visitor_Answer>;
  /** fetch data from the table: "visitor_question" */
  visitor_question: Array<Visitor_Question>;
  /** fetch aggregated fields from the table: "visitor_question" */
  visitor_question_aggregate: Visitor_Question_Aggregate;
  /** fetch data from the table: "visitor_question" using primary key columns */
  visitor_question_by_pk?: Maybe<Visitor_Question>;
};


export type Query_RootAdArgs = {
  distinct_on?: InputMaybe<Array<Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Order_By>>;
  where?: InputMaybe<Ad_Bool_Exp>;
};


export type Query_RootAd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Order_By>>;
  where?: InputMaybe<Ad_Bool_Exp>;
};


export type Query_RootAd_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAd_CycleArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


export type Query_RootAd_Cycle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


export type Query_RootAd_Cycle_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAd_EventArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


export type Query_RootAd_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


export type Query_RootAd_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


export type Query_RootAuthOauth2AuthRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


export type Query_RootAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthOauth2AuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


export type Query_RootAuthOauth2AuthorizationCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


export type Query_RootAuthOauth2ClientArgs = {
  clientId: Scalars['String'];
};


export type Query_RootAuthOauth2ClientsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};


export type Query_RootAuthOauth2ClientsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};


export type Query_RootAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


export type Query_RootAuthOauth2RefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String'];
};


export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBucketArgs = {
  id: Scalars['String'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootCategory_TagArgs = {
  distinct_on?: InputMaybe<Array<Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Tag_Order_By>>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};


export type Query_RootCategory_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Tag_Order_By>>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};


export type Query_RootCategory_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCheckImageArgs = {
  url: Scalars['String'];
};


export type Query_RootCommunication_Opt_InArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


export type Query_RootCommunication_Opt_In_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


export type Query_RootCommunication_Opt_In_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFileArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFuzzy_Search_CategoriesArgs = {
  args: Fuzzy_Search_Categories_Arguments;
  distinct_on?: InputMaybe<Array<Fuzzy_Category_Tag_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fuzzy_Category_Tag_Order_By>>;
  where?: InputMaybe<Fuzzy_Category_Tag_Bool_Exp_Bool_Exp>;
};


export type Query_RootFuzzy_Search_ListingsArgs = {
  args: Fuzzy_Search_Listings_Arguments;
  distinct_on?: InputMaybe<Array<Fuzzy_Listing_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fuzzy_Listing_Order_By>>;
  where?: InputMaybe<Fuzzy_Listing_Bool_Exp_Bool_Exp>;
};


export type Query_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Query_RootImage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Query_RootImage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootListingArgs = {
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Query_RootListing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Query_RootListing_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootListing_Category_TagArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


export type Query_RootListing_Category_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


export type Query_RootListing_Category_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPromo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Query_RootPromo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Query_RootPromo_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSearch_ListingsArgs = {
  args: Search_Listings_Args;
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Query_RootSearch_Listings_AggregateArgs = {
  args: Search_Listings_Args;
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Query_RootUserArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVisitor_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


export type Query_RootVisitor_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


export type Query_RootVisitor_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVisitor_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Question_Order_By>>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};


export type Query_RootVisitor_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Question_Order_By>>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};


export type Query_RootVisitor_Question_By_PkArgs = {
  id: Scalars['Int'];
};

export type Search_Listings_Args = {
  search?: InputMaybe<Scalars['String']>;
  search_island?: InputMaybe<Scalars['String']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "ad" */
  ad: Array<Ad>;
  /** fetch aggregated fields from the table: "ad" */
  ad_aggregate: Ad_Aggregate;
  /** fetch data from the table: "ad" using primary key columns */
  ad_by_pk?: Maybe<Ad>;
  /** fetch data from the table: "ad_cycle" */
  ad_cycle: Array<Ad_Cycle>;
  /** fetch aggregated fields from the table: "ad_cycle" */
  ad_cycle_aggregate: Ad_Cycle_Aggregate;
  /** fetch data from the table: "ad_cycle" using primary key columns */
  ad_cycle_by_pk?: Maybe<Ad_Cycle>;
  /** fetch data from the table in a streaming manner: "ad_cycle" */
  ad_cycle_stream: Array<Ad_Cycle>;
  /** fetch data from the table: "ad_event" */
  ad_event: Array<Ad_Event>;
  /** fetch aggregated fields from the table: "ad_event" */
  ad_event_aggregate: Ad_Event_Aggregate;
  /** fetch data from the table: "ad_event" using primary key columns */
  ad_event_by_pk?: Maybe<Ad_Event>;
  /** fetch data from the table in a streaming manner: "ad_event" */
  ad_event_stream: Array<Ad_Event>;
  /** fetch data from the table in a streaming manner: "ad" */
  ad_stream: Array<Ad>;
  /** fetch data from the table: "auth.oauth2_auth_requests" using primary key columns */
  authOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>;
  /** fetch data from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests: Array<AuthOauth2AuthRequests>;
  /** fetch aggregated fields from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequestsAggregate: AuthOauth2AuthRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests_stream: Array<AuthOauth2AuthRequests>;
  /** fetch data from the table: "auth.oauth2_authorization_codes" using primary key columns */
  authOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>;
  /** fetch data from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes: Array<AuthOauth2AuthorizationCodes>;
  /** fetch aggregated fields from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodesAggregate: AuthOauth2AuthorizationCodes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes_stream: Array<AuthOauth2AuthorizationCodes>;
  /** fetch data from the table: "auth.oauth2_clients" using primary key columns */
  authOauth2Client?: Maybe<AuthOauth2Clients>;
  /** fetch data from the table: "auth.oauth2_clients" */
  authOauth2Clients: Array<AuthOauth2Clients>;
  /** fetch aggregated fields from the table: "auth.oauth2_clients" */
  authOauth2ClientsAggregate: AuthOauth2Clients_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.oauth2_clients" */
  authOauth2Clients_stream: Array<AuthOauth2Clients>;
  /** fetch data from the table: "auth.oauth2_refresh_tokens" using primary key columns */
  authOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>;
  /** fetch data from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens: Array<AuthOauth2RefreshTokens>;
  /** fetch aggregated fields from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokensAggregate: AuthOauth2RefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens_stream: Array<AuthOauth2RefreshTokens>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "category_tag" */
  category_tag: Array<Category_Tag>;
  /** fetch aggregated fields from the table: "category_tag" */
  category_tag_aggregate: Category_Tag_Aggregate;
  /** fetch data from the table: "category_tag" using primary key columns */
  category_tag_by_pk?: Maybe<Category_Tag>;
  /** fetch data from the table in a streaming manner: "category_tag" */
  category_tag_stream: Array<Category_Tag>;
  /** fetch data from the table: "communication_opt_in" */
  communication_opt_in: Array<Communication_Opt_In>;
  /** fetch aggregated fields from the table: "communication_opt_in" */
  communication_opt_in_aggregate: Communication_Opt_In_Aggregate;
  /** fetch data from the table: "communication_opt_in" using primary key columns */
  communication_opt_in_by_pk?: Maybe<Communication_Opt_In>;
  /** fetch data from the table in a streaming manner: "communication_opt_in" */
  communication_opt_in_stream: Array<Communication_Opt_In>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  fuzzy_search_categories: Array<Fuzzy_Category_Tag>;
  fuzzy_search_listings: Array<Fuzzy_Listing>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch aggregated fields from the table: "image" */
  image_aggregate: Image_Aggregate;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table in a streaming manner: "image" */
  image_stream: Array<Image>;
  /** fetch data from the table: "listing" */
  listing: Array<Listing>;
  /** fetch aggregated fields from the table: "listing" */
  listing_aggregate: Listing_Aggregate;
  /** fetch data from the table: "listing" using primary key columns */
  listing_by_pk?: Maybe<Listing>;
  /** fetch data from the table: "listing_category_tag" */
  listing_category_tag: Array<Listing_Category_Tag>;
  /** fetch aggregated fields from the table: "listing_category_tag" */
  listing_category_tag_aggregate: Listing_Category_Tag_Aggregate;
  /** fetch data from the table: "listing_category_tag" using primary key columns */
  listing_category_tag_by_pk?: Maybe<Listing_Category_Tag>;
  /** fetch data from the table in a streaming manner: "listing_category_tag" */
  listing_category_tag_stream: Array<Listing_Category_Tag>;
  /** fetch data from the table in a streaming manner: "listing" */
  listing_stream: Array<Listing>;
  /** fetch data from the table: "promo_code" */
  promo_code: Array<Promo_Code>;
  /** fetch aggregated fields from the table: "promo_code" */
  promo_code_aggregate: Promo_Code_Aggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promo_code_by_pk?: Maybe<Promo_Code>;
  /** fetch data from the table in a streaming manner: "promo_code" */
  promo_code_stream: Array<Promo_Code>;
  /** execute function "search_listings" which returns "listing" */
  search_listings: Array<Listing>;
  /** execute function "search_listings" and query aggregates on result of table type "listing" */
  search_listings_aggregate: Listing_Aggregate;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "visitor_answer" */
  visitor_answer: Array<Visitor_Answer>;
  /** fetch aggregated fields from the table: "visitor_answer" */
  visitor_answer_aggregate: Visitor_Answer_Aggregate;
  /** fetch data from the table: "visitor_answer" using primary key columns */
  visitor_answer_by_pk?: Maybe<Visitor_Answer>;
  /** fetch data from the table in a streaming manner: "visitor_answer" */
  visitor_answer_stream: Array<Visitor_Answer>;
  /** fetch data from the table: "visitor_question" */
  visitor_question: Array<Visitor_Question>;
  /** fetch aggregated fields from the table: "visitor_question" */
  visitor_question_aggregate: Visitor_Question_Aggregate;
  /** fetch data from the table: "visitor_question" using primary key columns */
  visitor_question_by_pk?: Maybe<Visitor_Question>;
  /** fetch data from the table in a streaming manner: "visitor_question" */
  visitor_question_stream: Array<Visitor_Question>;
};


export type Subscription_RootAdArgs = {
  distinct_on?: InputMaybe<Array<Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Order_By>>;
  where?: InputMaybe<Ad_Bool_Exp>;
};


export type Subscription_RootAd_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Order_By>>;
  where?: InputMaybe<Ad_Bool_Exp>;
};


export type Subscription_RootAd_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAd_CycleArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


export type Subscription_RootAd_Cycle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Cycle_Order_By>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


export type Subscription_RootAd_Cycle_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAd_Cycle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ad_Cycle_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Cycle_Bool_Exp>;
};


export type Subscription_RootAd_EventArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


export type Subscription_RootAd_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ad_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ad_Event_Order_By>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


export type Subscription_RootAd_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAd_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ad_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Event_Bool_Exp>;
};


export type Subscription_RootAd_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ad_Stream_Cursor_Input>>;
  where?: InputMaybe<Ad_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthRequests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthOauth2AuthRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthOauth2AuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthorizationCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


export type Subscription_RootAuthOauth2AuthorizationCodes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthOauth2AuthorizationCodes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>;
};


export type Subscription_RootAuthOauth2ClientArgs = {
  clientId: Scalars['String'];
};


export type Subscription_RootAuthOauth2ClientsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};


export type Subscription_RootAuthOauth2ClientsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};


export type Subscription_RootAuthOauth2Clients_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthOauth2Clients_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>;
};


export type Subscription_RootAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthOauth2RefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthOauth2RefreshTokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthOauth2RefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootCategory_TagArgs = {
  distinct_on?: InputMaybe<Array<Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Tag_Order_By>>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};


export type Subscription_RootCategory_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Tag_Order_By>>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};


export type Subscription_RootCategory_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCategory_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Category_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Category_Tag_Bool_Exp>;
};


export type Subscription_RootCommunication_Opt_InArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


export type Subscription_RootCommunication_Opt_In_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


export type Subscription_RootCommunication_Opt_In_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommunication_Opt_In_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Communication_Opt_In_Stream_Cursor_Input>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFuzzy_Search_CategoriesArgs = {
  args: Fuzzy_Search_Categories_Arguments;
  distinct_on?: InputMaybe<Array<Fuzzy_Category_Tag_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fuzzy_Category_Tag_Order_By>>;
  where?: InputMaybe<Fuzzy_Category_Tag_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootFuzzy_Search_ListingsArgs = {
  args: Fuzzy_Search_Listings_Arguments;
  distinct_on?: InputMaybe<Array<Fuzzy_Listing_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fuzzy_Listing_Order_By>>;
  where?: InputMaybe<Fuzzy_Listing_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootImage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootImage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootImage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootListingArgs = {
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Subscription_RootListing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Subscription_RootListing_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootListing_Category_TagArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


export type Subscription_RootListing_Category_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listing_Category_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Category_Tag_Order_By>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


export type Subscription_RootListing_Category_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootListing_Category_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Listing_Category_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Listing_Category_Tag_Bool_Exp>;
};


export type Subscription_RootListing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Listing_Stream_Cursor_Input>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Subscription_RootPromo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootPromo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootPromo_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPromo_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Promo_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootSearch_ListingsArgs = {
  args: Search_Listings_Args;
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Subscription_RootSearch_Listings_AggregateArgs = {
  args: Search_Listings_Args;
  distinct_on?: InputMaybe<Array<Listing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listing_Order_By>>;
  where?: InputMaybe<Listing_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVisitor_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


export type Subscription_RootVisitor_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


export type Subscription_RootVisitor_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVisitor_Answer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Visitor_Answer_Stream_Cursor_Input>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


export type Subscription_RootVisitor_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Question_Order_By>>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};


export type Subscription_RootVisitor_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Question_Order_By>>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};


export type Subscription_RootVisitor_Question_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVisitor_Question_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Visitor_Question_Stream_Cursor_Input>>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl: Scalars['String'];
  /** An array relationship */
  communication_opt_ins: Array<Communication_Opt_In>;
  /** An aggregate relationship */
  communication_opt_ins_aggregate: Communication_Opt_In_Aggregate;
  createdAt: Scalars['timestamptz'];
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole: Scalars['String'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['citext']>;
  emailVerified: Scalars['Boolean'];
  id: Scalars['uuid'];
  isAnonymous: Scalars['Boolean'];
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  newEmail?: Maybe<Scalars['citext']>;
  /** An array relationship */
  oauth2AuthRequests: Array<AuthOauth2AuthRequests>;
  /** An aggregate relationship */
  oauth2AuthRequests_aggregate: AuthOauth2AuthRequests_Aggregate;
  /** An array relationship */
  oauth2RefreshTokens: Array<AuthOauth2RefreshTokens>;
  /** An aggregate relationship */
  oauth2RefreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt: Scalars['timestamptz'];
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified: Scalars['Boolean'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt: Scalars['timestamptz'];
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
  /** An array relationship */
  visitor_answers: Array<Visitor_Answer>;
  /** An aggregate relationship */
  visitor_answers_aggregate: Visitor_Answer_Aggregate;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersCommunication_Opt_InsArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersCommunication_Opt_Ins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Opt_In_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Opt_In_Order_By>>;
  where?: InputMaybe<Communication_Opt_In_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2AuthRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>;
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2RefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>;
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersVisitor_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersVisitor_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp>;
  avatarUrl?: InputMaybe<String_Comparison_Exp>;
  communication_opt_ins?: InputMaybe<Communication_Opt_In_Bool_Exp>;
  communication_opt_ins_aggregate?: InputMaybe<Communication_Opt_In_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: InputMaybe<String_Comparison_Exp>;
  defaultRole?: InputMaybe<String_Comparison_Exp>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  newEmail?: InputMaybe<Citext_Comparison_Exp>;
  oauth2AuthRequests?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>;
  oauth2AuthRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp>;
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>;
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>;
  otpHash?: InputMaybe<String_Comparison_Exp>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>;
  passwordHash?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  ticket?: InputMaybe<String_Comparison_Exp>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  totpSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>;
  visitor_answers?: InputMaybe<Visitor_Answer_Bool_Exp>;
  visitor_answers_aggregate?: InputMaybe<Visitor_Answer_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  communication_opt_ins?: InputMaybe<Communication_Opt_In_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  defaultRole?: InputMaybe<Scalars['String']>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['citext']>;
  emailVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  newEmail?: InputMaybe<Scalars['citext']>;
  oauth2AuthRequests?: InputMaybe<AuthOauth2AuthRequests_Arr_Rel_Insert_Input>;
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>;
  otpHash?: InputMaybe<Scalars['String']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']>;
  passwordHash?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['String']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  totpSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>;
  visitor_answers?: InputMaybe<Visitor_Answer_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>;
  avatarUrl?: InputMaybe<Order_By>;
  communication_opt_ins_aggregate?: InputMaybe<Communication_Opt_In_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentChallenge?: InputMaybe<Order_By>;
  defaultRole?: InputMaybe<Order_By>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>;
  disabled?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAnonymous?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  newEmail?: InputMaybe<Order_By>;
  oauth2AuthRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Order_By>;
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>;
  otpHash?: InputMaybe<Order_By>;
  otpHashExpiresAt?: InputMaybe<Order_By>;
  otpMethodLastUsed?: InputMaybe<Order_By>;
  passwordHash?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  phoneNumberVerified?: InputMaybe<Order_By>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticketExpiresAt?: InputMaybe<Order_By>;
  totpSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>;
  visitor_answers_aggregate?: InputMaybe<Visitor_Answer_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  defaultRole?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['citext']>;
  emailVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  newEmail?: InputMaybe<Scalars['citext']>;
  otpHash?: InputMaybe<Scalars['String']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']>;
  passwordHash?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']>;
  ticket?: InputMaybe<Scalars['String']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  totpSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  defaultRole?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['citext']>;
  emailVerified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  newEmail?: InputMaybe<Scalars['citext']>;
  otpHash?: InputMaybe<Scalars['String']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']>;
  passwordHash?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']>;
  ticket?: InputMaybe<Scalars['String']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  totpSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  userSession: Scalars['jsonb'];
  virus: Scalars['String'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userSession?: InputMaybe<Scalars['jsonb']>;
  virus?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  virus?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  virus?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userSession?: InputMaybe<Scalars['jsonb']>;
  virus?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userSession?: InputMaybe<Scalars['jsonb']>;
  virus?: InputMaybe<Scalars['String']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

/** visitor's answer to a user poll question */
export type Visitor_Answer = {
  __typename?: 'visitor_answer';
  answer: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  question_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  visitor_question: Visitor_Question;
};


/** visitor's answer to a user poll question */
export type Visitor_AnswerAnswerArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "visitor_answer" */
export type Visitor_Answer_Aggregate = {
  __typename?: 'visitor_answer_aggregate';
  aggregate?: Maybe<Visitor_Answer_Aggregate_Fields>;
  nodes: Array<Visitor_Answer>;
};

export type Visitor_Answer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Visitor_Answer_Aggregate_Bool_Exp_Count>;
};

export type Visitor_Answer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Visitor_Answer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "visitor_answer" */
export type Visitor_Answer_Aggregate_Fields = {
  __typename?: 'visitor_answer_aggregate_fields';
  avg?: Maybe<Visitor_Answer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Visitor_Answer_Max_Fields>;
  min?: Maybe<Visitor_Answer_Min_Fields>;
  stddev?: Maybe<Visitor_Answer_Stddev_Fields>;
  stddev_pop?: Maybe<Visitor_Answer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Visitor_Answer_Stddev_Samp_Fields>;
  sum?: Maybe<Visitor_Answer_Sum_Fields>;
  var_pop?: Maybe<Visitor_Answer_Var_Pop_Fields>;
  var_samp?: Maybe<Visitor_Answer_Var_Samp_Fields>;
  variance?: Maybe<Visitor_Answer_Variance_Fields>;
};


/** aggregate fields of "visitor_answer" */
export type Visitor_Answer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "visitor_answer" */
export type Visitor_Answer_Aggregate_Order_By = {
  avg?: InputMaybe<Visitor_Answer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Visitor_Answer_Max_Order_By>;
  min?: InputMaybe<Visitor_Answer_Min_Order_By>;
  stddev?: InputMaybe<Visitor_Answer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Visitor_Answer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Visitor_Answer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Visitor_Answer_Sum_Order_By>;
  var_pop?: InputMaybe<Visitor_Answer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Visitor_Answer_Var_Samp_Order_By>;
  variance?: InputMaybe<Visitor_Answer_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Visitor_Answer_Append_Input = {
  answer?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "visitor_answer" */
export type Visitor_Answer_Arr_Rel_Insert_Input = {
  data: Array<Visitor_Answer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Visitor_Answer_On_Conflict>;
};

/** aggregate avg on columns */
export type Visitor_Answer_Avg_Fields = {
  __typename?: 'visitor_answer_avg_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "visitor_answer" */
export type Visitor_Answer_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "visitor_answer". All fields are combined with a logical 'AND'. */
export type Visitor_Answer_Bool_Exp = {
  _and?: InputMaybe<Array<Visitor_Answer_Bool_Exp>>;
  _not?: InputMaybe<Visitor_Answer_Bool_Exp>;
  _or?: InputMaybe<Array<Visitor_Answer_Bool_Exp>>;
  answer?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  visitor_question?: InputMaybe<Visitor_Question_Bool_Exp>;
};

/** unique or primary key constraints on table "visitor_answer" */
export enum Visitor_Answer_Constraint {
  /** unique or primary key constraint on columns "id" */
  VisitorAnswerPkey = 'visitor_answer_pkey',
  /** unique or primary key constraint on columns "user_id", "question_id" */
  VisitorAnswerQuestionIdUserIdKey = 'visitor_answer_question_id_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Visitor_Answer_Delete_At_Path_Input = {
  answer?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Visitor_Answer_Delete_Elem_Input = {
  answer?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Visitor_Answer_Delete_Key_Input = {
  answer?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "visitor_answer" */
export type Visitor_Answer_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "visitor_answer" */
export type Visitor_Answer_Insert_Input = {
  answer?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_email?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  visitor_question?: InputMaybe<Visitor_Question_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Visitor_Answer_Max_Fields = {
  __typename?: 'visitor_answer_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "visitor_answer" */
export type Visitor_Answer_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Visitor_Answer_Min_Fields = {
  __typename?: 'visitor_answer_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "visitor_answer" */
export type Visitor_Answer_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "visitor_answer" */
export type Visitor_Answer_Mutation_Response = {
  __typename?: 'visitor_answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Visitor_Answer>;
};

/** on_conflict condition type for table "visitor_answer" */
export type Visitor_Answer_On_Conflict = {
  constraint: Visitor_Answer_Constraint;
  update_columns?: Array<Visitor_Answer_Update_Column>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};

/** Ordering options when selecting data from "visitor_answer". */
export type Visitor_Answer_Order_By = {
  answer?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  visitor_question?: InputMaybe<Visitor_Question_Order_By>;
};

/** primary key columns input for table: visitor_answer */
export type Visitor_Answer_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Visitor_Answer_Prepend_Input = {
  answer?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "visitor_answer" */
export enum Visitor_Answer_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "visitor_answer" */
export type Visitor_Answer_Set_Input = {
  answer?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Visitor_Answer_Stddev_Fields = {
  __typename?: 'visitor_answer_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "visitor_answer" */
export type Visitor_Answer_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Visitor_Answer_Stddev_Pop_Fields = {
  __typename?: 'visitor_answer_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "visitor_answer" */
export type Visitor_Answer_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Visitor_Answer_Stddev_Samp_Fields = {
  __typename?: 'visitor_answer_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "visitor_answer" */
export type Visitor_Answer_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "visitor_answer" */
export type Visitor_Answer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visitor_Answer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visitor_Answer_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Visitor_Answer_Sum_Fields = {
  __typename?: 'visitor_answer_sum_fields';
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "visitor_answer" */
export type Visitor_Answer_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** update columns of table "visitor_answer" */
export enum Visitor_Answer_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id'
}

export type Visitor_Answer_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Visitor_Answer_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Visitor_Answer_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Visitor_Answer_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Visitor_Answer_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Visitor_Answer_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Visitor_Answer_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Visitor_Answer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Visitor_Answer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Visitor_Answer_Var_Pop_Fields = {
  __typename?: 'visitor_answer_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "visitor_answer" */
export type Visitor_Answer_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Visitor_Answer_Var_Samp_Fields = {
  __typename?: 'visitor_answer_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "visitor_answer" */
export type Visitor_Answer_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Visitor_Answer_Variance_Fields = {
  __typename?: 'visitor_answer_variance_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "visitor_answer" */
export type Visitor_Answer_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** admin-configurable questions for polling users */
export type Visitor_Question = {
  __typename?: 'visitor_question';
  active: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  label: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  order: Scalars['Int'];
  question_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  visitor_answers: Array<Visitor_Answer>;
  /** An aggregate relationship */
  visitor_answers_aggregate: Visitor_Answer_Aggregate;
};


/** admin-configurable questions for polling users */
export type Visitor_QuestionMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** admin-configurable questions for polling users */
export type Visitor_QuestionVisitor_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};


/** admin-configurable questions for polling users */
export type Visitor_QuestionVisitor_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visitor_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visitor_Answer_Order_By>>;
  where?: InputMaybe<Visitor_Answer_Bool_Exp>;
};

/** aggregated selection of "visitor_question" */
export type Visitor_Question_Aggregate = {
  __typename?: 'visitor_question_aggregate';
  aggregate?: Maybe<Visitor_Question_Aggregate_Fields>;
  nodes: Array<Visitor_Question>;
};

/** aggregate fields of "visitor_question" */
export type Visitor_Question_Aggregate_Fields = {
  __typename?: 'visitor_question_aggregate_fields';
  avg?: Maybe<Visitor_Question_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Visitor_Question_Max_Fields>;
  min?: Maybe<Visitor_Question_Min_Fields>;
  stddev?: Maybe<Visitor_Question_Stddev_Fields>;
  stddev_pop?: Maybe<Visitor_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Visitor_Question_Stddev_Samp_Fields>;
  sum?: Maybe<Visitor_Question_Sum_Fields>;
  var_pop?: Maybe<Visitor_Question_Var_Pop_Fields>;
  var_samp?: Maybe<Visitor_Question_Var_Samp_Fields>;
  variance?: Maybe<Visitor_Question_Variance_Fields>;
};


/** aggregate fields of "visitor_question" */
export type Visitor_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visitor_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Visitor_Question_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Visitor_Question_Avg_Fields = {
  __typename?: 'visitor_question_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "visitor_question". All fields are combined with a logical 'AND'. */
export type Visitor_Question_Bool_Exp = {
  _and?: InputMaybe<Array<Visitor_Question_Bool_Exp>>;
  _not?: InputMaybe<Visitor_Question_Bool_Exp>;
  _or?: InputMaybe<Array<Visitor_Question_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  question_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visitor_answers?: InputMaybe<Visitor_Answer_Bool_Exp>;
  visitor_answers_aggregate?: InputMaybe<Visitor_Answer_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "visitor_question" */
export enum Visitor_Question_Constraint {
  /** unique or primary key constraint on columns "id" */
  VisitorQuestionPkey = 'visitor_question_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Visitor_Question_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Visitor_Question_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Visitor_Question_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "visitor_question" */
export type Visitor_Question_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "visitor_question" */
export type Visitor_Question_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  order?: InputMaybe<Scalars['Int']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visitor_answers?: InputMaybe<Visitor_Answer_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Visitor_Question_Max_Fields = {
  __typename?: 'visitor_question_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  question_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Visitor_Question_Min_Fields = {
  __typename?: 'visitor_question_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  question_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "visitor_question" */
export type Visitor_Question_Mutation_Response = {
  __typename?: 'visitor_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Visitor_Question>;
};

/** input type for inserting object relation for remote table "visitor_question" */
export type Visitor_Question_Obj_Rel_Insert_Input = {
  data: Visitor_Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Visitor_Question_On_Conflict>;
};

/** on_conflict condition type for table "visitor_question" */
export type Visitor_Question_On_Conflict = {
  constraint: Visitor_Question_Constraint;
  update_columns?: Array<Visitor_Question_Update_Column>;
  where?: InputMaybe<Visitor_Question_Bool_Exp>;
};

/** Ordering options when selecting data from "visitor_question". */
export type Visitor_Question_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visitor_answers_aggregate?: InputMaybe<Visitor_Answer_Aggregate_Order_By>;
};

/** primary key columns input for table: visitor_question */
export type Visitor_Question_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Visitor_Question_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "visitor_question" */
export enum Visitor_Question_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "visitor_question" */
export type Visitor_Question_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  order?: InputMaybe<Scalars['Int']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Visitor_Question_Stddev_Fields = {
  __typename?: 'visitor_question_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Visitor_Question_Stddev_Pop_Fields = {
  __typename?: 'visitor_question_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Visitor_Question_Stddev_Samp_Fields = {
  __typename?: 'visitor_question_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "visitor_question" */
export type Visitor_Question_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visitor_Question_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visitor_Question_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  order?: InputMaybe<Scalars['Int']>;
  question_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Visitor_Question_Sum_Fields = {
  __typename?: 'visitor_question_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "visitor_question" */
export enum Visitor_Question_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Visitor_Question_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Visitor_Question_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Visitor_Question_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Visitor_Question_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Visitor_Question_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Visitor_Question_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Visitor_Question_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Visitor_Question_Set_Input>;
  /** filter the rows which have to be updated */
  where: Visitor_Question_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Visitor_Question_Var_Pop_Fields = {
  __typename?: 'visitor_question_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Visitor_Question_Var_Samp_Fields = {
  __typename?: 'visitor_question_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Visitor_Question_Variance_Fields = {
  __typename?: 'visitor_question_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type CheckImageQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CheckImageQuery = { __typename?: 'query_root', checkImage: { __typename?: 'CheckImagePayload', success: boolean, error?: string | null, existing_url?: string | null } };

export type UploadImageMutationVariables = Exact<{
  entityId: Scalars['Int'];
  src: Scalars['String'];
  destination?: InputMaybe<Scalars['String']>;
}>;


export type UploadImageMutation = { __typename?: 'mutation_root', uploadImage: { __typename?: 'UploadImagePayload', success: boolean, error?: string | null, new_url?: string | null } };

export type UpdateLayoutDataMutationVariables = Exact<{
  id: Scalars['Int'];
  layoutData: Scalars['jsonb'];
}>;


export type UpdateLayoutDataMutation = { __typename?: 'mutation_root', update_listing_by_pk?: { __typename?: 'listing', id: number } | null };

export type FixImageMutationVariables = Exact<{
  entityId: Scalars['Int'];
  src: Scalars['String'];
}>;


export type FixImageMutation = { __typename?: 'mutation_root', uploadImage: { __typename?: 'UploadImagePayload', success: boolean, error?: string | null, fixed_url?: string | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  displayName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: any } | null };

export type CreateListingShellMutationVariables = Exact<{
  businessName: Scalars['String'];
  slug: Scalars['String'];
}>;


export type CreateListingShellMutation = { __typename?: 'mutation_root', insert_listing_one?: { __typename?: 'listing', id: number } | null };

export type DeleteListingMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteListingMutation = { __typename?: 'mutation_root', delete_listing_by_pk?: { __typename?: 'listing', id: number } | null };

export type UpdateListingMutationVariables = Exact<{
  id: Scalars['Int'];
  set: Listing_Set_Input;
}>;


export type UpdateListingMutation = { __typename?: 'mutation_root', update_listing_by_pk?: { __typename?: 'listing', id: number } | null };

export type CreatePromoCodeMutationVariables = Exact<{
  pc: Promo_Code_Insert_Input;
}>;


export type CreatePromoCodeMutation = { __typename?: 'mutation_root', insert_promo_code_one?: { __typename?: 'promo_code', id: number } | null };

export type UpdatePromoCodeMutationVariables = Exact<{
  id: Scalars['Int'];
  set: Promo_Code_Set_Input;
}>;


export type UpdatePromoCodeMutation = { __typename?: 'mutation_root', update_promo_code_by_pk?: { __typename?: 'promo_code', id: number } | null };

export type DeletePromoCodeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePromoCodeMutation = { __typename?: 'mutation_root', delete_promo_code_by_pk?: { __typename?: 'promo_code', id: number } | null };

export type CreateCategoryMutationVariables = Exact<{
  label: Scalars['String'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCategoryMutation = { __typename?: 'mutation_root', insert_category_tag_one?: { __typename?: 'category_tag', id: number } | null };

export type UpdateCategoryByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  set?: InputMaybe<Category_Tag_Set_Input>;
}>;


export type UpdateCategoryByIdMutation = { __typename?: 'mutation_root', update_category_tag_by_pk?: { __typename?: 'category_tag', id: number } | null };

export type DeleteCategoryByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCategoryByIdMutation = { __typename?: 'mutation_root', delete_category_tag_by_pk?: { __typename?: 'category_tag', id: number } | null };

export type DeleteCategoryListingByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCategoryListingByIdMutation = { __typename?: 'mutation_root', delete_listing_category_tag_by_pk?: { __typename?: 'listing_category_tag', id: number } | null };

export type RemoveCategoryListingsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type RemoveCategoryListingsMutation = { __typename?: 'mutation_root', delete_listing_category_tag?: { __typename?: 'listing_category_tag_mutation_response', affected_rows: number } | null };

export type CreateCategoryListingsMutationVariables = Exact<{
  objects: Array<Listing_Category_Tag_Insert_Input> | Listing_Category_Tag_Insert_Input;
}>;


export type CreateCategoryListingsMutation = { __typename?: 'mutation_root', insert_listing_category_tag?: { __typename?: 'listing_category_tag_mutation_response', affected_rows: number } | null };

export type CreateAdMutationVariables = Exact<{
  object: Ad_Insert_Input;
}>;


export type CreateAdMutation = { __typename?: 'mutation_root', insert_ad_one?: { __typename?: 'ad', id: number } | null };

export type UpdateAdMutationVariables = Exact<{
  id: Scalars['Int'];
  set?: InputMaybe<Ad_Set_Input>;
}>;


export type UpdateAdMutation = { __typename?: 'mutation_root', update_ad_by_pk?: { __typename?: 'ad', id: number } | null };

export type CreateAdCycleMutationVariables = Exact<{
  object: Ad_Cycle_Insert_Input;
}>;


export type CreateAdCycleMutation = { __typename?: 'mutation_root', insert_ad_cycle_one?: { __typename?: 'ad_cycle', id: number } | null };

export type UpdateAdCycleByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  set?: InputMaybe<Ad_Cycle_Set_Input>;
}>;


export type UpdateAdCycleByIdMutation = { __typename?: 'mutation_root', update_ad_cycle_by_pk?: { __typename?: 'ad_cycle', id: number } | null };

export type DeleteAdCycleByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAdCycleByIdMutation = { __typename?: 'mutation_root', delete_ad_cycle_by_pk?: { __typename?: 'ad_cycle', id: number } | null };

export type DeleteAdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAdMutation = { __typename?: 'mutation_root', delete_ad_by_pk?: { __typename?: 'ad', id: number } | null };

export type CreateVisitorQuestionMutationVariables = Exact<{
  input: Visitor_Question_Insert_Input;
}>;


export type CreateVisitorQuestionMutation = { __typename?: 'mutation_root', insert_visitor_question_one?: { __typename?: 'visitor_question', id: number } | null };

export type UpdateVisitorQuestionMutationVariables = Exact<{
  id: Scalars['Int'];
  set?: InputMaybe<Visitor_Question_Set_Input>;
}>;


export type UpdateVisitorQuestionMutation = { __typename?: 'mutation_root', update_visitor_question_by_pk?: { __typename?: 'visitor_question', id: number } | null };

export type UpdateVisitorQuestionsMutationVariables = Exact<{
  updates: Array<Visitor_Question_Updates> | Visitor_Question_Updates;
}>;


export type UpdateVisitorQuestionsMutation = { __typename?: 'mutation_root', update_visitor_question_many?: Array<{ __typename?: 'visitor_question_mutation_response', affected_rows: number } | null> | null };

export type DeleteVisitorQuestionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteVisitorQuestionMutation = { __typename?: 'mutation_root', delete_visitor_question_by_pk?: { __typename?: 'visitor_question', id: number } | null };

export type AllListingsSubscriptionVariables = Exact<{
  orderBy?: InputMaybe<Array<Listing_Order_By> | Listing_Order_By>;
  where?: InputMaybe<Listing_Bool_Exp>;
}>;


export type AllListingsSubscription = { __typename?: 'subscription_root', listing: Array<{ __typename?: 'listing', business_name: string, island?: string | null, created_at: any, updated_at: any, id: number, tier: string, live: boolean, this_week_recommended: boolean, is_island_original: boolean, promoted: boolean }> };

export type AllListingsWithCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllListingsWithCategoriesQuery = { __typename?: 'query_root', listing: Array<{ __typename?: 'listing', id: number, business_name: string, live: boolean, listing_category_tags: Array<{ __typename?: 'listing_category_tag', id: number, category_tag_id: number }> }> };

export type FuzzySearchListingsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  includeNonLive?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<Array<Fuzzy_Listing_Order_By> | Fuzzy_Listing_Order_By>;
}>;


export type FuzzySearchListingsQuery = { __typename?: 'query_root', fuzzy_search_listings: Array<{ __typename?: 'fuzzy_listing', id: number }> };

export type ListingByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ListingByIdQuery = { __typename?: 'query_root', listing_by_pk?: { __typename?: 'listing', id: number, slug: string, business_name: string, slogan?: string | null, description?: string | null, rich_description?: string | null, island?: string | null, created_at: any, updated_at: any, tier: string, promoted: boolean, live: boolean, primary_address?: string | null, primary_phone?: string | null, primary_email?: string | null, primary_web_url?: string | null, this_week_recommended: boolean, is_island_original: boolean, booking_links: any, business_hours: any, breadcrumbs?: any | null, social_media: any, promo_code_visitor_hook?: string | null, promo_code_count?: number | null, images: any, videos: any, layout_data: any, lat_lng?: any | null, listing_category_tags: Array<{ __typename?: 'listing_category_tag', id: number, category_tag_id: number }>, promo_codes: Array<{ __typename?: 'promo_code', id: number, code: string, label?: string | null, expiration?: any | null }> } | null };

export type ListingsByCategoryQueryVariables = Exact<{
  categoryId: Scalars['Int'];
}>;


export type ListingsByCategoryQuery = { __typename?: 'query_root', listing: Array<{ __typename?: 'listing', id: number, business_name: string, listing_category_tags: Array<{ __typename?: 'listing_category_tag', id: number }> }> };

export type GetAdByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAdByIdQuery = { __typename?: 'query_root', ad_by_pk?: { __typename?: 'ad', id: number, created_at: any, name: string, link: string, image: string, size: string } | null };

export type AllAdsQueryVariables = Exact<{
  whereClause?: InputMaybe<Ad_Bool_Exp>;
}>;


export type AllAdsQuery = { __typename?: 'query_root', ad: Array<{ __typename?: 'ad', id: number, created_at: any, updated_at: any, name: string, link: string, image: string, size: string }> };

export type GetAdCyclesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdCyclesQuery = { __typename?: 'query_root', ad: Array<{ __typename?: 'ad', id: number, name: string, image: string, link: string, size: string, ad_cycles: Array<{ __typename?: 'ad_cycle', id: number, starts_at: any, ends_at: any, loads: number }> }> };

export type AdCycleStatsByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AdCycleStatsByIdQuery = { __typename?: 'query_root', ad_cycle_by_pk?: { __typename?: 'ad_cycle', ad_events_aggregate: { __typename?: 'ad_event_aggregate', aggregate?: { __typename?: 'ad_event_aggregate_fields', variance?: { __typename?: 'ad_event_variance_fields', id?: number | null, ad_cycle_id?: number | null } | null } | null } } | null };

export type CycleAnalyticsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CycleAnalyticsQuery = { __typename?: 'query_root', ad_cycle_by_pk?: { __typename?: 'ad_cycle', id: number, loads: number, clicks: { __typename?: 'ad_event_aggregate', aggregate?: { __typename?: 'ad_event_aggregate_fields', count: number } | null }, unique_clicks: { __typename?: 'ad_event_aggregate', aggregate?: { __typename?: 'ad_event_aggregate_fields', count: number } | null }, views: { __typename?: 'ad_event_aggregate', aggregate?: { __typename?: 'ad_event_aggregate_fields', count: number } | null }, unique_views: { __typename?: 'ad_event_aggregate', aggregate?: { __typename?: 'ad_event_aggregate_fields', count: number } | null } } | null };

export type GetCategoryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoryTagsQuery = { __typename?: 'query_root', category_tag: Array<{ __typename?: 'category_tag', id: number, label: string, is_primary: boolean, listing_category_tags_aggregate: { __typename?: 'listing_category_tag_aggregate', aggregate?: { __typename?: 'listing_category_tag_aggregate_fields', count: number } | null } }> };

export type BreadcrumbsQueryVariables = Exact<{ [key: string]: never; }>;


export type BreadcrumbsQuery = { __typename?: 'query_root', listing: Array<{ __typename?: 'listing', breadcrumbs?: any | null }> };

export type GetRegistrationQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistrationQuestionsQuery = { __typename?: 'query_root', visitor_question: Array<{ __typename?: 'visitor_question', id: number, label: string, question_type: string, active: boolean, metadata?: any | null, order: number, visitor_answers_aggregate: { __typename?: 'visitor_answer_aggregate', aggregate?: { __typename?: 'visitor_answer_aggregate_fields', count: number } | null } }> };

export type VisitorsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisitorsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null, displayName: string, lastSeen?: any | null, defaultRole: string }> };

export type AllAnswersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAnswersQuery = { __typename?: 'query_root', visitor_answer: Array<{ __typename?: 'visitor_answer', id: number, question_id: number, user_id?: any | null, answer: any, created_at: any }> };

export type VisitorAnswersQueryVariables = Exact<{ [key: string]: never; }>;


export type VisitorAnswersQuery = { __typename?: 'query_root', visitor_answer: Array<{ __typename?: 'visitor_answer', id: number, question_id: number, answer: any, created_at: any, updated_at: any, user_id?: any | null }> };

export type VisitorAnswersByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type VisitorAnswersByUserIdQuery = { __typename?: 'query_root', visitor_answer: Array<{ __typename?: 'visitor_answer', id: number, question_id: number, answer: any, created_at: any, updated_at: any, user_id?: any | null }> };

export type VisitorQuestionWithAnswersQueryVariables = Exact<{
  questionId: Scalars['Int'];
}>;


export type VisitorQuestionWithAnswersQuery = { __typename?: 'query_root', visitor_question_by_pk?: { __typename?: 'visitor_question', id: number, label: string, question_type: string, active: boolean, metadata?: any | null, order: number, visitor_answers: Array<{ __typename?: 'visitor_answer', id: number, user_id?: any | null, answer: any, created_at: any }> } | null };


export const CheckImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"existing_url"}}]}}]}}]} as unknown as DocumentNode<CheckImageQuery, CheckImageQueryVariables>;
export const UploadImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"src"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"src"},"value":{"kind":"Variable","name":{"kind":"Name","value":"src"}}},{"kind":"Argument","name":{"kind":"Name","value":"destination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"new_url"}}]}}]}}]} as unknown as DocumentNode<UploadImageMutation, UploadImageMutationVariables>;
export const UpdateLayoutDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLayoutData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_listing_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_append"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"layout_data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLayoutDataMutation, UpdateLayoutDataMutationVariables>;
export const FixImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fixImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"src"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"src"},"value":{"kind":"Variable","name":{"kind":"Name","value":"src"}}},{"kind":"Argument","name":{"kind":"Name","value":"fix"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_url"}}]}}]}}]} as unknown as DocumentNode<FixImageMutation, FixImageMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_append"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const CreateListingShellDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingShell"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_listing_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"business_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateListingShellMutation, CreateListingShellMutationVariables>;
export const DeleteListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_listing_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteListingMutation, DeleteListingMutationVariables>;
export const UpdateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"listing_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_listing_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateListingMutation, UpdateListingMutationVariables>;
export const CreatePromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"promo_code_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_promo_code_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pc"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePromoCodeMutation, CreatePromoCodeMutationVariables>;
export const UpdatePromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"promo_code_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_promo_code_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePromoCodeMutation, UpdatePromoCodeMutationVariables>;
export const DeletePromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_promo_code_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePromoCodeMutation, DeletePromoCodeMutationVariables>;
export const CreateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"label"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPrimary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_category_tag_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"Variable","name":{"kind":"Name","value":"label"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPrimary"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"category_tag_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_category_tag_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCategoryByIdMutation, UpdateCategoryByIdMutationVariables>;
export const DeleteCategoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCategoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_category_tag_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCategoryByIdMutation, DeleteCategoryByIdMutationVariables>;
export const DeleteCategoryListingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCategoryListingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_listing_category_tag_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCategoryListingByIdMutation, DeleteCategoryListingByIdMutationVariables>;
export const RemoveCategoryListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCategoryListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_listing_category_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RemoveCategoryListingsMutation, RemoveCategoryListingsMutationVariables>;
export const CreateCategoryListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCategoryListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"listing_category_tag_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_listing_category_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CreateCategoryListingsMutation, CreateCategoryListingsMutationVariables>;
export const CreateAdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ad_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ad_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAdMutation, CreateAdMutationVariables>;
export const UpdateAdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ad_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ad_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAdMutation, UpdateAdMutationVariables>;
export const CreateAdCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAdCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ad_cycle_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ad_cycle_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAdCycleMutation, CreateAdCycleMutationVariables>;
export const UpdateAdCycleByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAdCycleById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ad_cycle_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_ad_cycle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAdCycleByIdMutation, UpdateAdCycleByIdMutationVariables>;
export const DeleteAdCycleByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAdCycleById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_ad_cycle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAdCycleByIdMutation, DeleteAdCycleByIdMutationVariables>;
export const DeleteAdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_ad_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAdMutation, DeleteAdMutationVariables>;
export const CreateVisitorQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVisitorQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"visitor_question_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_visitor_question_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateVisitorQuestionMutation, CreateVisitorQuestionMutationVariables>;
export const UpdateVisitorQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVisitorQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"visitor_question_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_visitor_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateVisitorQuestionMutation, UpdateVisitorQuestionMutationVariables>;
export const UpdateVisitorQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVisitorQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"visitor_question_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_visitor_question_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateVisitorQuestionsMutation, UpdateVisitorQuestionsMutationVariables>;
export const DeleteVisitorQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVisitorQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_visitor_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteVisitorQuestionMutation, DeleteVisitorQuestionMutationVariables>;
export const AllListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"listing_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"listing_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"island"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"this_week_recommended"}},{"kind":"Field","name":{"kind":"Name","value":"is_island_original"}},{"kind":"Field","name":{"kind":"Name","value":"promoted"}}]}}]}}]} as unknown as DocumentNode<AllListingsSubscription, AllListingsSubscriptionVariables>;
export const AllListingsWithCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllListingsWithCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"business_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"listing_category_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category_tag_id"}}]}}]}}]}}]} as unknown as DocumentNode<AllListingsWithCategoriesQuery, AllListingsWithCategoriesQueryVariables>;
export const FuzzySearchListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FuzzySearchListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeNonLive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fuzzy_listing_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fuzzy_search_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"include_non_live"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNonLive"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FuzzySearchListingsQuery, FuzzySearchListingsQueryVariables>;
export const ListingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingByID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"rich_description"}},{"kind":"Field","name":{"kind":"Name","value":"island"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"promoted"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"primary_address"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_web_url"}},{"kind":"Field","name":{"kind":"Name","value":"this_week_recommended"}},{"kind":"Field","name":{"kind":"Name","value":"is_island_original"}},{"kind":"Field","name":{"kind":"Name","value":"booking_links"}},{"kind":"Field","name":{"kind":"Name","value":"business_hours"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumbs"}},{"kind":"Field","name":{"kind":"Name","value":"social_media"}},{"kind":"Field","name":{"kind":"Name","value":"promo_code_visitor_hook"}},{"kind":"Field","name":{"kind":"Name","value":"promo_code_count"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"layout_data"}},{"kind":"Field","name":{"kind":"Name","value":"lat_lng"}},{"kind":"Field","name":{"kind":"Name","value":"listing_category_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category_tag_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promo_codes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}}]}}]}}]}}]} as unknown as DocumentNode<ListingByIdQuery, ListingByIdQueryVariables>;
export const ListingsByCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingsByCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_category_tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"category_tag_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"listing_category_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"category_tag_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ListingsByCategoryQuery, ListingsByCategoryQueryVariables>;
export const GetAdByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]} as unknown as DocumentNode<GetAdByIdQuery, GetAdByIdQueryVariables>;
export const AllAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ad_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]} as unknown as DocumentNode<AllAdsQuery, AllAdsQueryVariables>;
export const GetAdCyclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdCycles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"ad_cycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"starts_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_at"}},{"kind":"Field","name":{"kind":"Name","value":"ends_at"}},{"kind":"Field","name":{"kind":"Name","value":"loads"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdCyclesQuery, GetAdCyclesQueryVariables>;
export const AdCycleStatsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdCycleStatsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad_cycle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad_events_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ad_cycle_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdCycleStatsByIdQuery, AdCycleStatsByIdQueryVariables>;
export const CycleAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cycleAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad_cycle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loads"}},{"kind":"Field","alias":{"kind":"Name","value":"clicks"},"name":{"kind":"Name","value":"ad_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"click","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unique_clicks"},"name":{"kind":"Name","value":"ad_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unique"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"click","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views"},"name":{"kind":"Name","value":"ad_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"view","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unique_views"},"name":{"kind":"Name","value":"ad_events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unique"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"view","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CycleAnalyticsQuery, CycleAnalyticsQueryVariables>;
export const GetCategoryTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategoryTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"listing_category_tags_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoryTagsQuery, GetCategoryTagsQueryVariables>;
export const BreadcrumbsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Breadcrumbs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"breadcrumbs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"ListValue","values":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breadcrumbs"}}]}}]}}]} as unknown as DocumentNode<BreadcrumbsQuery, BreadcrumbsQueryVariables>;
export const GetRegistrationQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRegistrationQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitor_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"question_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"visitor_answers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRegistrationQuestionsQuery, GetRegistrationQuestionsQueryVariables>;
export const VisitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Visitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastSeen"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRole"}}]}}]}}]} as unknown as DocumentNode<VisitorsQuery, VisitorsQueryVariables>;
export const AllAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitor_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<AllAnswersQuery, AllAnswersQueryVariables>;
export const VisitorAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"visitorAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitor_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question_id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<VisitorAnswersQuery, VisitorAnswersQueryVariables>;
export const VisitorAnswersByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"visitorAnswersByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitor_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question_id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<VisitorAnswersByUserIdQuery, VisitorAnswersByUserIdQueryVariables>;
export const VisitorQuestionWithAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisitorQuestionWithAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitor_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"question_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"visitor_answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]} as unknown as DocumentNode<VisitorQuestionWithAnswersQuery, VisitorQuestionWithAnswersQueryVariables>;